import dmi from './utils/deep-merge-inmutable'
import base from './base'
export default dmi(base, {
  message: {
    billboard: {
        search: 'Procurar',
    },
    abm: {
      folders: {
        errors: {
          '10001': 'idCarpeta es un valor requerido',
          '10002': 'idCarpeta no es un valor entero válido',
          '10003': 'nombre es un valor requerido',
          '10004': 'nombre no es un valor alfanumérico válido',
          '10005': 'tipo es un valor requerido',
          '10006': 'tipo no es un valor alfanumérico válido',
          '10007': 'visible es un valor requerido',
          '10008': 'visible no tiene un valor booleano válido',
          '10009': 'firmable no tiene un valor booleano válido',
          '10010': 'efimero no tiene un valor booleano válido',
          '10011': 'El alias no es un valor alfanumérico válido',
          '10012': 'idTemplate no es un valor entero válido',
          '10013': 'sinCodigo no tiene un valor booleano válido',
          '10014': 'parser no es un valor alfabético válido',
          '10015': 'Hay una subcarpeta con ese nombre',
          '10016': 'Hay una subcarpeta con ese alias',
          '10017': 'template inválido',
          '10018': 'No hay una carpeta con ese id',
          '10019': 'idSubCarpeta is not a valid number',
          '10020': 'No hay una subcarpeta con ese id',
          '10021': 'Esta subcarpeta no se puede eliminar',
          '10022': 'No se puede modificar el valor del tipo',
          '10023': 'idTemplate es un valor requerido',
          '10024': 'No puede agregar un idTemplate con visible deshabilitado',
          '10025': 'Faltan parámetros',
          '10026': 'Los parámetros están vacíos',
          '10027': 'name no es un valor alfanumérico válido',
          '10028': 'Una o varias carpetas no pueden ser bloquedas',
          '10029': 'order no es un valor entero válido',
          '10030': 'El nombre de esta carpeta no se puede modificar',
          '10031': 'No puede ser efimero con firmable desactivado',
          '10032': 'No se puede bloquear con visible deshabilitado',
          '10033': 'name es un valor requerido',
          '10034': 'firmable es un valor requerido',
          '10035': 'efimero es un valor requerido',
          '10036': 'Ya existe una carpeta con este nombre en el sistema',
          '10037': 'No puede ser firmable con visible desactivado',
          '10038':
            'No se pudo eliminar la carpeta. La carpeta contiene documentos cargados.',
          '10039': 'No tiene posicionamiento de firma por default',
          '10040': 'Sin posicionamiento de firma para esta subcarpeta',
          '10041': 'El directorio no existe',
          '10042': 'No se pudo crear el pdf',
          '10043':
            'No se pudo agregar el archivo de posicionamiento de la firma',
          '10044': 'No se pudo crear la imagen en miniatura',
          '10045': 'No se pudo guardar en el storage',
          '10046': 'No se pudo eliminar el archivo de posición de la firma',
          '10047': 'No se pudo eliminar la posición de la firma',
          '10048': 'La paginación no es un valor de string válido',
          '10049': 'No se puede procesar el corte del PDF',
          '10050': 'El valor de rotacion es inválido',
          '10051': 'Archivo PDF no válido',
          '10052': 'El PDF supera el peso máximo de 5MB',
          '10053': 'La firma del colaborador es un valor requerido',
          '10054': 'Formato de firma del colaborador es inválido',
          '10055': 'Formato de firma del empleador es inválido',
          '10056': 'File es un valor requerido',
          '10057':
            'No puede editar este tipo de documento porque el identificador único no está definido correctamente. Comuniquese con soporte',
          '10058': 'No se pudo agregar el posicionamiento de la firma',
          '10059':
            'No es posible eliminar la carpeta, existen filtros por carpeta asociados a algunos usuarios',
          '10061': 'El parámetro sendIa es un valor requerido',
          '268': 'Este PDF está encriptado e não pode ser processado',
          unknown: 'Error desconocido',
          SYSTEM_API_INVALID_PDF_FILE_SIZE:
            'El PDF supera el peso máximo de 5MB.',
          SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
            'El PDF supera el peso máximo de 5MB.',
          SYSTEM_API_WRONG_MIME_TYPE: 'El tipo soportado es archivos PDF.',
          NO_SUPPORTED:
            'El tamaño del PDF a cargar puede ser A3, A4, A5, Legal, Carta ó Minimo <span class="font-bold">147mm x 209mm</span> y Máximo <span class="font-bold">298mm x 421mm</span> ',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE:
            'El tipo de documento {docName} ya tiene habilitada la opción de análisis por IA.',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE_DESCRIPTION:
            'Este atributo únicamente puede estar disponible para un tipo de documento.'
        },
        modals: {
          cancelFolder: {
            title: 'Configuración de carpetas',
            label:
              '¿Estas seguro de que quieres salir de la configuración de carpeta?',
            label1:
              'Todos los cambios realizados en esta configuración seran descartados',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, salir'
          },
          cancelSubFolder: {
            title: 'Salir de la configuración de tipo documento',
            label: '¿Estás seguro de que quieres salir de la configuración de',
            label1: 'tipo de documento',
            label2:
              'Todos los cambios realizados en esta configuración serán descartados',
            label3:
              'Puedes continuar con la creación de documentos en cualquier momento',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, salir'
          },
          deleteFolder: {
            title: 'Eliminar carpeta',
            label: 'Estas seguro de querer eliminar la carpeta',
            label1: 'También se eliminarán los tipos de documentos asociados.',
            label2: 'Esta acción no se puede deshacer',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, eliminarla'
          },
          deleteSubFolder: {
            title: 'Eliminar tipo de documento',
            label: 'Estás seguro de querer eliminar',
            label1: ' Esta acción no se puede deshacer',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, eliminarlo'
          },
          deleteSubFolderConfig: {
            label:
              '¿Estás seguro de que quieres eliminar la configuración actual del documento?'
          },
          emailPreview: {
            title: 'Vista previa',
            label: 'Hola',
            label1:
              'Le informamos que cuenta con un nuevo documento pendiente por firmar en la bandeja de TuRecibo',
            label2: 'Ingresar al sistema',
            label3: 'Saludos',
            label4: 'Equipo de',
            label5:
              'NOTA: Favor no responder este mensaje que ha sido generado automáticamente desde TuRecibo. Esta comunicación (incluidos sus anexos) contiene información confidencial, dirigida exclusivamente a su destinatario, quien deberá resguardar la confidencialidad. Queda prohibido la divulgación, modificación, reproducción o uso de la información aquí contenida por cualquier otra persona que no sea su destinatario',
            buttonPrimary: 'Cerrar vista previa'
          },
          generic: {
            title: 'Configuración de carpetas',
            buttonPrimary: 'Entendido'
          },
          cancelSubFolderConfig: {
            cancelQuestion:
              '¿Desea aplicar los cambios antes de salir de la configuración del documento?',
            dismiss: 'Descartar',
            ok: 'Sí, aplicar'
          },
          confirmSubFolderConfig: {
            confirmQuestion:
              '¿Estás seguro de que quieres guardar los cambios realizados en el documento?',
            ok: 'Aceptar'
          }
        },
        settings: {
          folderName: {
            default: 'Nueva Carpeta',
            question: '¿Cúal es el nombre de esta carpeta?',
            description:
              'El nombre de la carpeta te va a servir para identificar los documentos que se guarden en la misma, trata de que sea un nombre descriptivo'
          },
          persistDocument: {
            question:
              '¿Los documentos permanecen en la bandeja de tu colaborador?',
            description:
              'Todos los documentos van a permanecer en la bandeja de entrada de tu colaborador para que los pueda visualizar, descargar e imprimirlos',
            option: {
              label: 'Visibles',
              legend:
                'Luego de firmarlo permanecen en la bandeja de tu colaborador'
            },
            option1: {
              label: 'Ocultarlos',
              legend:
                'Luego de firmarlo permanecen en la bandeja de tu colaborador'
            }
          },
          requiresSignature: {
            question: '¿Requiere firma del colaborador?',
            description:
              'Los documentos de esta carpeta van a aparecerle a tu colaborador en su bandeja de entrada para que lo pueda firmar',
            option: {
              label: 'Requiere firma'
            },
            option1: {
              label: 'No requiere firma'
            }
          },
          signaturePriority: {
            question: '¿Esta carpeta tiene prioridad para ser firmada?',
            question1: 'Selecciona la carpeta que tiene prioridad de firma',
            description:
              'El colaborador tiene que firmar primero los documentos de esta carpeta para luego continuar con el resto de los documentos',
            description1:
              'Esta carpeta es prioritaria y requiere firma del colaborador',
            option: {
              label: 'No tiene prioridad'
            },
            option1: {
              label: 'Si tiene prioridad'
            },
            select: 'Selecciona la carpeta',
            placeholder: 'Busca o selecciona del listado',
            selectLabel: 'Presione enter para seleccionar',
            selectGroupLabel: 'Presione enter para seleccionar el grupo',
            selectedLabel: 'Seleccionada',
            deselectLabel: 'Presione enter para eliminar',
            deselectGroupLabel:
              'Presione enter para anular la selección del grupo',
            noResult: 'No se encontraron resultados'
          },
          visibleDocuments: {
            question:
              '¿Los documentos son visibles en la bandeja de tu colaborador?',
            description:
              'Todos los documentos van a ser visibles en la bandeja de entrada de tu colaborador para que los pueda visualizar, descargar e imprimirlos',
            option: {
              label: 'Sí, son visibles',
              legend: 'Los documentos aparecen en la bandeja de tu colaborador'
            },
            option1: {
              label: 'No, ocultarlos',
              legend:
                'Los documentos no aparecen en la bandeja de tu colaborador'
            }
          },
          defaultPosition: {
            label: 'Puedes reemplazar este archivo desde',
            label1: 'subir pdf'
          },
          deleteSignature: {
            label: 'Eliminar firma',
            question:
              '¿Queres eliminar la firma que configuraste para esta carpeta?',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Si, eliminarla'
          },
          positionSignature: {
            question: '¿Como quieres posicionar la firma en el documento?',
            description:
              'Ubica en el documento el lugar donde van a impactar las firma que realice el colaborador',
            option: {
              label: 'No mostrar firma'
            },
            option1: {
              label: 'Mostrar firma'
            },
            label: 'Editar',
            label1: 'Establecer ubicación de firma'
          },
          signatureTools: {
            label: 'Utilizar pdf propio',
            label1: 'Subir pdf',
            label2: 'Eliminar pdf',
            label3: '¿Queres eliminar el pdf?',
            label4: 'Esta acción no se puede deshacer',
            label5: 'Página a firmar',
            label6: 'Primera',
            label7: 'Ultima',
            label8: 'Personalizar',
            label9: 'El numero de página es inexistente',
            label10: 'Orientación',
            label11: 'Vertical',
            label12: 'Horizontal',
            label13: 'Tamaño papel',
            label14: 'Formato',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Si, eliminar',
            buttonPrimary1: 'Aceptar'
          },
          documentIdentificator: {
            question:
              '¿Cómo quieres utilizar el identificador unico en el documento?',
            description:
              'Puedes seleccionar la forma de detectarlo en el documento, puede ser por el nombre del archivo o realizando un escaneo en la primera página dentro del documento'
          },
          alias: {
            question:
              '¿Quieres modificar el nombre del documento enviado por email?',
            description:
              'Puedes modificar el nombre del documento que recibe tu colaborador en su casilla de email para que sea mas facil la identificación del mismo',
            option: {
              label: 'Utilizar el nombre por defecto',
              legend: 'El nombre por defecto que tiene el documento'
            },
            option1: {
              label: 'Modificar el nombre del documento',
              legend: 'Cambiar el nombre del documento por otro mas descriptivo'
            },
            preview: 'Previsualizar email'
          },
          documentType: {
            question: '¿Este tipo de documento es un formulario digital?',
            option: {
              label: 'Sí'
            },
            option1: {
              label: 'No'
            }
          },
          documentXML: {
            question: '¿Se debe adjuntar documento XML?',
            option: {
              label: 'Sí'
            },
            option1: {
              label: 'No'
            }
          },
          loadDocument: {
            question: '¿El colaborador puede cargar este tipo de documentos?',
            question1: '¿Cuantas páginas de este documento son necesarias?',
            description:
              'Tu colaborador puede subir este tipo de documento a la plataforma para que lo puedas recibir y tomar acciones',
            description1:
              'Es necesario que selecciones la cantidad de páginas totales del documento y cuantas páginas del mismo son obligatorias',
            option: {
              label: 'No carga documentos',
              legend: 'El colaborador no puede subir este tipo de documentos'
            },
            option1: {
              label: 'Carga documentos',
              legend: 'El colaborador puede subir este tipo de documentos'
            }
          },
          subFolderName: {
            default: 'Tipo de documento',
            question: '¿Cúal es el nombre de este tipo de documento?',
            description:
              'El nombre del tipo de documento te va a servir para identificarlos, trata de que sea un nombre descriptivo'
          },
          genericDocument: {
            question: '¿El documento corresponde a una publicación genérica?',
            description:
              'Enviar un mismo documento masivamente a más de un colaborador sin necesidad de que el mismo posea un identificador único',
            option: {
              label: 'No es una publicación genérica',
              legend: ''
            },
            option1: {
              label: 'Si es una publicación genérica',
              legend: ''
            }
          }
        },
        table: {
          perPage: 'Cantidad por página',
          eform: 'Formulario',
          pdfxml: 'PDF+XML',
          documentType: 'Tipos de documentos'
        },
        folderEmpty: {
          label: 'Esto es un desierto...',
          label1: 'Aún no hay carpeta creadas',
          link: 'Crear carpeta'
        },
        subFolderEmpty: {
          label: 'esta vacía',
          label1: '¿Quieres crear un tipo de documento?',
          buttonPrimary: 'Crear tipo de documento',
          buttonSecondary: 'En otro momento'
        },
        folderList: {
          title: 'Carpetas creadas',
          buttonPrimary: 'Crear carpeta',
          header: {
            name: 'Nombre de carpeta',
            visible: 'Visible para empleado',
            signature: 'Requiere firma',
            ephemeral: 'Oculto luego de firmar'
          }
        },
        subFolderList: {
          buttonPrimary: 'Crear tipo de documento',
          header: {
            name: 'Nombre tipo documento',
            documents: 'Documentos genéricos',
            publish: 'Colaborador puede publicar',
            signature: 'Posición de firma'
          }
        },
        title: 'Configuración de carpetas',
        tooltipFolder: 'La carpeta posee documentos dentro',
        deleteFolder: 'Eliminar carpeta',
        cancelFolder: 'Cancelar',
        saveFolder: 'Guardar carpeta',
        tooltipSubFolder: 'El tipo de documento posee documentos dentro',
        deleteSubFolder: 'Eliminar tipo de documento',
        cancelSubFolder: 'Cancelar',
        saveSubFolder: 'Guardar documento',
        toolbox: {
          deletePdf: 'Excluir PDF',
          questionPdf: '¿Você deseja excluir o PDF?',
          notUndo: 'Essa ação não pode ser desfeita',
          cancel: 'Cancelar',
          confirmDelete: 'Sim, excluir',
          cutPdf: 'Selecione a área de corte dentro do documento',
          applyCut: 'Aplicar recorte',
          applying: 'Aplicando corte...',
          cutDone: 'Corte feito',
          undo: 'Reiniciar',
          undoTitle: 'Reiniciar o documento',
          questionUndo: '¿Deseja desfazer a alteração de corte?',
          confirmUndo: 'Sim, reiniciar',
          rotation: 'Você pode girar o documento 90°',
          leftDir: 'Vire à esquerda',
          rightDir: 'Vire à direita',
          undoRotation: '¿Deseja desfazer as alterações de rotação??',
          signShow: 'Mostrar assinatura no documento',
          singDescription:
            'Você pode configurar a posição da assinatura e a página do documento em que deseja que ela apareça',
          firstPage: 'Primeiro',
          lastPage: 'Último',
          customPage: 'Personalizar',
          singQuestion:
            'Deseja retornar ao posicionamento de assinatura padrão?',
          singEmpQuestion:
            'Deseja desfazer a alteração do posicionamento da assinatura do empregador?',
          loading: 'Subindo...'
        },
        signatureTool: {
          singEmployee: 'Assinatura do Colaborador',
          singDescription: 'Aqui aparecerá a assinatura do colaborador',
          singEmployer: 'Empresa de assinatura',
          singDescriptionEmployer: 'Aqui aparecerá a assinatura da Empresa'
        },
        emptyState: {
          title: 'Você pode substituir este arquivo de',
          link: 'carregar pdf'
        },
        pdfInfo: {
          size: 'Tamanho',
          page: 'Página'
        },
        configurationDocumentModal: 'Configuración de documento',
        settingPanel: {
          loadDocument: 'Carregar um documento',
          loadPdf: 'Carregar pdf',
          actions: 'Ações',
          position: 'Posicionamento',
          exit: 'Sair',
          ok: 'Aceitar'
        }
      }
    },
    actions: {
      delete: 'Remover',
      atention: 'Atenção',
      error: 'Erro',
      not_founded: 'Nao encontrado',
      empty_list: 'Lista vazia',
      remove: 'Remover',
      empty_user: 'Desculpe, mas não encontramos nenhum usuário',
      max_elements: 'No máximo um item selecionado'
    },
    unsubscribe: {
      confirm_unsubscribe_question:
        'Tem certeza de que deseja desvincular o funcionário?',
      confirm_unsubscribe_why: 'Selecione um motivo para demitir o funcionário',
      confirm_unsubscribe_why_title: 'Motivo',
      confirm_unsubscribe_observation: 'Observações',
      confirm_unsubscribe_yes: 'Sim',
      confirm_unsubscribe_no: 'Não',
      confirm_unsubscribe_success: 'O funcionário foi desativado com sucesso',
      date: 'Data de Desvinculação',
      date_invalid: 'Necesita ingresar una fecha de baja',
      title: 'Desvinculación masiva de Empleados',
      description1:
        'En ésta sección usted podrá cambiar el estado de los usuarios a inactivo para que los mismos no puedan seguir recibiendo noticias, solicitando licencias ni enviar documentación.',
      description2:
        'Los usuarios podrán seguir accediendo a la plataforma para consultar los documentos que tienen en su bandeja.',
      description3:
        'Desde el detalle del empleado usted podrá reactivarlo en caso de ser necesario.',
      step_1_title: '1. Crear archivo de usuarios',
      step_1_content:
        'Cree un archivo CSV que contenga todos los usuarios que desea desvincular.  ',
      step_1_2_content:
        'para completar. Es importante que se respete la cabecera del archivo como primera línea.',
      step_2_title: '2. Seleccione un motivo',
      step_3_title: '3. Adjuntar archivo CSV',
      step_3_extension_dropzone: '*El formato del archivo deberá ser CSV',
      btn_save: 'Procesar archivo',
      alert_format: 'Formato de archivo no compatible',
      count_filename_1: 'Se actualizará el estado de',
      count_filename_2: 'usuarios',
      unsubscribe_valid_pass:
        '¿Está seguro/a que desea desvincular los empleados?',
      action_cancel: 'Cancelar',
      action_unsubscribe: 'Desvincular',
      text_fail_password: 'Contraseña incorrecta',
      text_modal_1: 'Su solicitud se encuentra en proceso',
      text_modal_2:
        'Usted puede volver al buscador de empleados para seguir administrando los empleados ó revisar la acción realizada en el estado de proceso.',
      back_to_search: 'Volver al buscador',
      action_go_process: 'Ir al estado de proceso',
      error_50024: 'El archivo no posee ningún tipo de información',
      error_50027:
        'El archivo esta incompleto, específicamente algun campo de identificador único',
      error_50022: 'El archivo posee formatos de fechas inválidas',
      error_50021:
        'El archivo no se puede procesar, específicamente algún campo de observación es demasiado largo',
      error_50020: 'El archivo no se puede procesar, existen campos vacios',
      error_50023: 'El archivo posee las cabecera inválidas',
      error_50028: 'El usuario de la sesión actual no se puede desactivar',
      error_05010:
        'La fecha de baja legal no puede ser menor a la fecha de contratación',
      error_05001:
        'No se desvinculó al empleado, el campo de usuario identificador es requerido',
      error_05002:
        'No se desvinculó al empleado, algún campo ingresado no tiene el formato crrecto',
      error_05003:
        'No se desvinculó al empleado, no se puede desvincular a si mismo',
      error_05004:
        'No se desvinculó al empleado, no tiene permisos para desvicular empleados',
      error_00005:
        'No se desvinculó al empleado, faltan llenar campos necesarios para desvincular',
      error_00072:
        'No se desvinculó al empleado, no se ha encontrado el usuario especificado en el sistema',
      error_50015:
        'No se desvinculó al empleado, el usuario identificado pertenece a otra empresa',
      error_default: 'Hubo un problema al dar de baja al usuario',
      error_20001: 'El modelo de organización debe ser numérico',
      error_20002: 'El modelo de organización enviado no es un valor válido',
      error_20003: 'No fue posible actualizar el modelo de organización',
      error_20004: 'La integración con Visma People no está disponible'
    },
    generalSettings: {
      title: 'Centro de seguridad',
      security_title: 'Seguridad',
      mfa_subtitle: 'Autenticación multifactor (MFA)',
      mfa_table_profile_header: 'Perfiles de Gestión',
      mfa_table_required_header: 'Requiere MFA',
      mfa_active_modal_title: 'Activar MFA',
      mfa_active_modal_description:
        'Es necesario que los usuarios pertenecientes a este perfil cuenten con un mail registrado, en caso de no tener uno, perderán el acceso a la cuenta hasta que registren una dirección de correo.',
      mfa_active_modal_cancel: 'Cancelar',
      mfa_active_modal_solicitar: 'Si, Solicitar',
      mfa_active_modal_confirm: 'Entendido',
      errorLogs: {
        unknown: 'Error desconocido',
        parameter_required: 'Faltan parámetros para realizar la operación',
        mfa_not_granted: 'No tiene permisos para realizar esta operación',
        parameter_lenght_exceeded: 'Parámetro con valor límite excedido',
        wrong_type_data: 'Parámetro incorrecto',
        parameter_not_expected: 'Parámetro no esperado',
        mfa_preference_profile_restricted:
          'No se puede agregar MFA para este tipo de perfil'
      }
    },
    mfa: {
      email_validation: {
        title: 'Ingresa un Email',
        sub_title_email_empty:
          'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresas en el siguiente paso.',
        sub_title_email_dirty:
          'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresas en el siguiente paso.',
        go_back_btn: 'Volver',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      max_exceeded_resend_fails_mails: {
        title: 'Código de verificación',
        sub_title_max_mails_resend_fails:
          'Realizó demasiados pedidos de verificación, por motivos de seguridad se inhabilitó su cuenta por 1 hora',
        sub_title_max_code_attempts:
          'Realizó demasiados intentos fallidos inicie sesión nuevamente',
        go_back_login_btn: 'Ir al login'
      },
      code_authentication: {
        title: 'Código de verificación',
        sub_title_wrong_code:
          'El código de verificación no es válido. Por favor, inténtelo de nuevo',
        sub_title_valid_code:
          'Ingresá el código de verificación de 6 números que te enviamos a tu email',
        sub_title_expired_code: 'Código expirado',
        sub_title_resend_code: 'Reenviar Código',
        sub_title_time_expired_code: 'El código expira en',
        go_back_btn: 'Volver',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      backup: {
        button: 'Realizar Backup',
        heading: 'Backup de Documentos',
        title:
          '¿Estas seguro que quieres solicitar un Backup de tus documentos?',
        content:
          'El Backup se generará y enviará por email luego de las 72 Horas para confirmar el proceso',
        heading_success: 'Solicitud realizada con éxito!',
        content_success:
          'Una vez generado el backup recibirá a su email un enlace para su descarga. La confirmación la recibirá 72hs después de la solicitud.'
      }
    },
    passwordExpired: {
      go_back_btn: 'Volver',
      update_pass_btn: 'Actualizar',
      go_to_dashboard: 'Ir al dashboard',
      pass_expired_message:
        'Tu contraseña expiró. Ingresa tu nueva contraseña.',
      message_error: {
        error_00019: 'La contraseña no cumple las políticas de la empresa',
        error_00026: 'No puede repetir las últimas 3 contraseñas',
        error_00033:
          'La nueva contraseña no puede ser igual a la contraseña actual',
        error_00141: 'La contraseña no cumple las políticas de la empresa',
        error_00024:
          'Hubo un problema al actualizar la contraseña, intente nuevamente',
        error_00046:
          'Ha realizado los cambios de contraseña máximos permitidos en el día. Su cuenta se restablecerá dentro de 24hs'
      },
      password_validation: {
        required: 'Este campo es requerido',
        no_match_pass: 'Las contraseñas ingresadas no coinciden',
        min_character_rule: 'Este campo debe contener al menos 8 caracteres',
        min_number_rule: 'Este campo debe contener al menos 1 número',
        min_character_info: 'Mínimo 8 caracteres, 1 número'
      },
      password_policies: {
        title: 'La contraseña debe contener:',
        history_pass: 'Distinta a las últimas input contraseñas',
        max_character: 'Máximo input caracteres',
        min_character: 'Mínimo input caracteres',
        no_expire: 'No expira',
        expire: 'Expira en input días',
        special_characters_amount: 'Al menos input caracteres especiales',
        min_numbers: 'Al menos input numero',
        min_capital_letter: 'Al menos input mayuscula',
        min_letter: 'Mínimo input letra(s)',
        notPersonalInfo: 'No puede contener información personal del usuario',
        notEasyPassw:
          'La contraseña no debe ser sencilla (ej. 12345678, qwerty, admin1234, etc.)'
      },
      success: {
        success_message: 'Contraseña actualizada correctamente',
        pls_go_back: 'Por favor, intente volver a ingresar al sistema.',
        go_back_btn: 'Volver al login'
      }
    },
    publishedEforms: {
      go_back_btn: 'Volver',
      parent_title: 'Resultado envíos',
      title: 'Publicaciones realizadas',
      columns: {
        sendBy: 'Enviado por',
        sendDate: 'Fecha y Hora',
        docTypes: 'Tipo documento',
        recipients: 'Destinatarios',
        status: 'Estado',
        actions: 'Acciones'
      },
      paginator: {
        rowsByPage: 'Resultados por página',
        of: 'de'
      },
      modalRevert: {
        title: 'Revertir envío',
        question: '¿Estas seguro que desea revertir el envío?',
        bodyContent:
          'Al revertir el envío, los formularios digitales involucrados se dejáran de ver en los legajos de cada colaborador, hayan sido completados o no.',
        btn_Revert: 'Si, revertilo'
      },
      filter: {
        title: 'Filtros',
        clear_filter_btn: 'Seleção clara',
        filter_btn: 'Filtro'
      }
    },
    folderSettings: {
      title: 'Configuración de carpetas',
      breadcrumbs_names: {
        0: 'Inicio',
        1: 'Configuración de carpetas'
      },
      subtitle: 'Carpetas disponibles',
      tableHeader: {
        name: 'Nombre',
        count: 'Cantidad',
        visible_for_employee: 'Visible para el empleado',
        signature_required: 'Requiere firma',
        hidden_after_signing: 'Oculto luego de firmar'
      },
      folderDetail: {
        visible: 'Visible',
        signature_required: 'Requiere firma',
        hidden_for_employee_after_signing:
          'Una vez firmado ocultar al empleado',
        keep_employee_inbox: 'Mantener en bandeja del empleado',
        selected_folder_to_block: 'Seleccione carpeta a bloquear',
        tooltip_folder_to_block:
          'Seleccione las carpetas que no podrá acceder hasta haber firmado todos los documentos contenidos en ésta. Ésto es opcional'
      },
      subFolder: {
        title: 'Subcarpetas',
        tableHeader: {
          name: 'Nombre'
        },
        detail: {
          content_eforms: 'Contiene formularios digitales',
          allow_generic_docs: 'Permite la publicación de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por el empleado',
          selected_template_label: 'Seleccione template',
          advance_config: {
            title: 'Configuración avanzada',
            parser_get_method: 'Método de captura',
            alias_alternative_name: 'Nombre alternativo'
          }
        },
        create: {
          content_eforms: 'Contiene formularios digitales',
          allow_generic_docs: 'Permite la publicación de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por el empleado',
          selected_template_label: 'Seleccione template',
          advance_config: {
            title: 'Configuración avanzada',
            parser_get_method: 'Método de captura',
            alias_alternative_name: 'Nombre alternativo'
          },
          save_btn: 'Guardar',
          input_placeholder_name: 'Nombre de subcarpeta',
          errors: {
            field_required: 'Este campo es requerido'
          },
          modals: {
            create_success: 'Se creo correctamente la subcarpeta',
            create_success_signature_position:
              'Se configuró el posicionamiento de firma por defecto, para aplicar uno personalizado contactate con soporte',
            create_failed: 'Ocurrio un error',
            question_exit_create: '¿Está seguro que desea cancelar la creación?'
          }
        },
        delete: {
          modals: {
            question_delete: '¿Desea eliminar la sub carpeta?',
            delete_success: 'Borrado correctamente',
            delete_failed: 'Ocurrió un error'
          }
        }
      },
      genericModals: {
        confirm_btn: 'Aceptar',
        cancel_btn: 'Cancelar'
      },
      errorLogs: {
        unknown: 'Error desconocido',
        id_folder_is_required: 'Id de carpeta es obligatorio',
        id_folder_not_valid_integer_value: 'Id de carpeta debe ser numérico',
        name_is_required_value: 'El nombre es obligatorio',
        name_is_not_valid_alphanumeric_value: 'El nombre debe ser alfanumérico',
        type_is_required_value: 'El tipo es obligatorio',
        type_not_valid_alphabetic_value: 'El tipo debe ser alfabético',
        visible_is_required_value: 'Visible es obligatorio',
        visible_does_not_have_valid_boolean_value:
          'Visible sólo admite verdadero/falso',
        signed_does_not_have_valid_boolean_value:
          'Firmable sólo admite verdadero/falso',
        ephemeral_does_not_have_valid_boolean_value:
          'Efimero sólo admite verdadero/falso',
        alias_is_not_valid_alphanumeric_value:
          'Nombre alternativo debe ser alfanumérico',
        id_template_is_not_valid_integer_value: 'Template incorrecto',
        without_code_does_not_have_valid_boolean_value:
          'Documentos genéricos solo admiten verdadero/falso',
        parser_is_not_valid_alphabetic_value:
          'Método de captura debe ser alfabético',
        there_is_sub_folder_with_that_name: 'La subcarpeta ya existe',
        there_is_sub_folder_with_that_alias: 'El nombre alternativo ya existe',
        there_is_not_template_with_that_id: 'Template incorrecto',
        there_is_not_folder_with_that_id: 'La carperta es incorrecta',
        id_sub_folder_is_not_valid_number: 'La subcarpeta es incorrecta',
        there_is_not_sub_folder_with_that_id: 'La subcarpeta es incorrecta',
        this_sub_folder_cant_be_remove:
          'La subcarpeta no se puede eliminar porque ya posee documentos asociados',
        type_of_sub_folder_is_not_modify:
          'El valor de (Contiene formularios digitales) no se puede modificar'
      }
    },
    listEmployees: {
      ob_down_employees: 'Baja masiva',
      tooltip_cargo:
        'Puesto que desarrolla el empleado en la compañía. Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el detalle del empleado',
      tooltip_report:
        'Jefe directo.  Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el "Legajo del empleado"'
    },
    login: {
      title_switch: 'Seleccionar Empresa',
      name_btn_switch: 'Ingresar',
      forgot_password: 'Se ha enviado un mail con las instrucciones',
      err404ForgotPass:
        'No encontramos el usuario / email por favor verifica los datos ingresados '
    },
    sso: {
      msgRedirectAuth: 'Autenticando...',
      msgRedirectLogin: 'Ingresando a TuRecibo',
      msgRedirectErrorLogin:
        'Ocurrio un error autentificando el usuario Intentelo nuevamente',
      msgRedirectLoginRRHH: 'Debes ser administrador para acceder'
    },
    userActive: {
      title_menu_personal_info: 'Informação pessoal',
      title_menu_configuration: 'Editar perfil',
      title_menu_onboarding: 'Onboarding',
      title_menu_licenses: 'Licenças',
      title_menu_documents: 'Documentos',
      title_employee_active: 'Funcionário Ativo',
      subtitle_employee_active: 'Informações do Usuário',
      subtitle_employee_active_onboarding:
        'Informações fornecidas pelo funcionário',
      subtitle_employee_active_onboarding_emergencia: 'Contato de emergência',
      subtitle_employee_configuration_profiles: 'Configurações de perfil',
      subtitle_employee_configuration_int_profiles: 'Perfis de integração',
      change_employee_configuration_profiles: 'Perfis modificados corretamente',
      change_employee_configuration_profiles_error:
        'Você deve selecionar pelo menos um perfil',
      profile_employee_title: 'Perfil do Funcionário',
      profile_management_title: 'Perfis de gerenciamento',
      profile_management_int_title: 'Atribuir perfis',
      profile_limited_access_title: 'Perfil com acesso limitado',
      profile_employee_tooltip:
        'Perfil desenvolvido para funcionários com permissão para visualizar, baixar e assinar seus recibos salariais. Somente um pode ser selecionado por usuário.',
      profile_management_tooltip:
        'Perfis projetados para o pessoal de recursos humanos.Permite gerenciar dados do usuário, notificações e recibos de salário.Somente um pode ser selecionado por usuário.',
      profile_limited_access_tooltip:
        'Perfil projetado para o pessoal de recursos humanos com acesso limitado. Permite gerenciar dados do usuário, notificações e recibos de salário. Somente um pode ser selecionado por usuário. Ao selecionar este perfil, você pode configurar os filtros por setor e / ou local abaixo.',
      select_profile: 'Selecione um perfil de administrador',
      title_employee_filter: 'Configurações de filtro',
      add_employee_filter: 'Adicionar',
      subtitle_employee_filter: 'Filtros atribuídos',
      name_employee_active_onboarding_emergencia:
        'Nome do contato de emergência',
      number_employee_active_onboarding_emergencia: 'Número de telefone',
      usuario: 'Usuário',
      nombre: 'Primeiro nome',
      apellido: 'Sobrenome',
      dni: 'Identidade',
      cuil: 'CPF',
      cuils: 'CPF',
      fecha_nacimiento: 'Data de nascimento',
      fecha_contratacion: 'Data de ingresao',
      mail: 'Mail',
      numero_legajo: 'Arquivo',
      information_general_employee_active:
        '(*) Corresponde às informações fornecidas pela área de Recursos Humanos',
      policies_employee_active: 'Veja nossa Política de Privacidade',
      empty_onboarding: 'Nenhum',
      title_position_ubication: 'Carga e localização',
      position_position_ubication: 'Carga',
      report_to_position_ubication: 'Relatar para',
      no_filter: 'Nenhum filtro definido',
      footer_filter:
        'Os filtros a seguir se aplicam ao perfil com acesso limitado',
      profile_employee: 'PERFIL DO FUNCIONÁRIO',
      profile_hhrr: 'PERFIL DE RH',
      other_profiles: 'PERFIS',
      remove_profiles: 'Remover perfil',
      title_license: 'Configurações de licenciamento',
      module_license: 'Usa módulo de licencias',
      subtitle_license: 'Usar módulo de licença',
      license_use_module: 'Usar módulo de licenciamento',
      only_rh: 'Apenas rh',
      level_one: 'Aprovador de Nível 1 e RH',
      level_two: 'Aprovador de nível 1 - Aprovador de nível 2 e RH',
      tiene_perfil_licencias: 'Perfil de Licenciamento',
      tiene_perfil_aprobador: 'É aprovador',
      approve_license_tooltip:
        'No caso de selecionar esta opção, qualquer funcionário pode selecionar esse usuário como seu aprovador de licença',
      numero_legajo_aprobador: 'Número de legajo del aprobador',
      niveles_aprobacion: 'Níveis de aprovação',
      id_politica: 'Políticas',
      antiguedad_previa: 'Antiguidade Anterior',
      antiquity_license_tooltip:
        'No caso de o empregado ter trabalhado anteriormente na empresa, aqui deve ser a antiguidade que se acumulou no referido período, indicando o número de meses trabalhados.',
      module_license_tooltip:
        'Ao ativar esta opção, você pode configurar os valores do módulo de licença como aprovadores, políticas aplicáveis ​​etc.',
      subtitle_folders_description:
        'Selecione as pastas que você verá na pesquisa de documentos',
      error_location_seccion_added: 'O setor e o local já foram adicionados',
      error_borndate: 'A data de nascimento é obrigatória',
      error_startdate: 'A data de contratação é obrigatória',
      error_username_change:
        'Você deve redefinir a senha do funcionário ao alterar o nome de usuário',
      error_cuil_change:
        'Si cambia este dato el usuario perderá los documentos asociados',
      error_sector_not_found: 'Sector no disponible',
      error_organization_model_not_found:
        'Modelo de organización no disponible',
      error_locacion_not_found: 'Locación no disponible',
      error_position_not_found: 'Cargo no disponible',
      max_elements: 'Máximo de um item selecionado',
      profiles_aclaration: 'Selecione o tipo de permissão do usuário',
      folders_aclaration:
        'Selecione as pastas que o usuário de gerenciamento pode acessar para consultar seu conteúdo',
      filter_aclaration:
        'Selecione o setor e o local dos funcionários que poderão acessar a exibição de seus documentos',
      empty_location_and_sector_text:
        'Você deve inserir pelo menos um local ou setor',
      human_resources: 'RH',
      select_folders: 'Selecionar pastas',
      select_location: 'Selecione um setor',
      select_position: 'Seleccione un cargo',
      select_section: 'Selecione um local',
      select_tag_sector: 'Al presionar Enter puedes agregar un nuevo sector',
      select_tag_location:
        'Al presionar Enter puedes agregar un nuevo locacion',
      select_tag_position: 'Al presionar Enter puedes agregar un nuevo cargo',
      tiene_licencias_progresivas: 'Licencias progresivas',
      inicio_dias_progresivos: 'Inicio de dias progresivos',
      fecha_inicio_licencias_progresivas: 'Fecha de inicio días progresivos',
      search_combo_reporta_a: 'Realice una búsqueda',
      estado: 'Estado',
      activo: 'Activo',
      inactivo: 'Inactivo',
      onboarding: 'Onboarding',
      noSector: 'SIN SECTOR',
      noLocation: 'SIN LOCACION',
      requiredDate: 'Es necesario que ingrese "Fecha de ingreso"',
      textFindLegajo: 'Realice la búsqueda del numero de legajo',
      noFilterSLxSector:
        'No ha seleccionado un filtro por sector y locación. El usuario podrá gestionar empleados del sector y locación al que pertenece',
      noFilterSLrrhh:
        'No ha seleccionado un filtro por sector y locación. El usuario podrá gestionar todos los empleados',
      noFilterFolders:
        'Ao aplicar um ou mais filtros por pasta, o usuário só poderá visualizar a documentação nas pastas selecionadas. Ao não aplicar nenhum filtro, o usuário poderá visualizar todos os documentos dos funcionários que gerencia, sem restrições.',
      foldersFilters: 'Filtros por carpeta',
      alertHasCertSign:
        'Éste perfil puede crear certificados electrónicos. No tienes permiso para realizar modificaciones, contáctate con soporte',
      certSignModal: {
        title: 'Guardar Perfil',
        text_1:
          'No tienes permiso para asignar el perfil de certificados electrónicos',
        text_2:
          'Para asignar el perfil con certificado, es necesario que te contactes con soporte',
        btnOk: 'Entendido'
      }
    },
    homeComponent: {
      birthdays: {
        title: 'Cumpleaños',
        no_events: 'Sin eventos',
        before_yesterday: 'Ante ayer',
        yesterday: 'Ayer',
        today: 'Hoy',
        tomorrow: 'Mañana',
        after_tomorrow: 'Pasado mañana'
      },
      recentHired: {
        title: 'Ingresos del mes',
        no_events: 'Sin eventos',
        show_more: 'Mostrar más',
        show_minus: 'Mostrar menos',
        teammate: 'Compañeros de equipo'
      },
      absentUsers: {
        title: 'Ausencias'
      }
    },
    searchComponent: {
      not_founded: 'No encontrado',
      max_elements: 'Máximo un elemento seleccionado'
    },
    label: {
      dni: 'Número de documento'
    },
    downloadBackup: {
      cancel: 'Cancelar',
      understood: 'Entender',
      downloadModal: {
        title: 'Download de backup',
        messageInitialDownload:
          'Download do documento iniciado automaticamente.',
        expiredDownload: 'O download de seus documentos expirou',
        problemWithDownloadLink: 'Se você tiver problemas com o download',
        clickHere: 'clique aqui',
        retryDownload:
          'Se você quiser tentar baixá-los novamente, vá para o navegador de documentos',
        mfaError: 'Você não ativou o fator de segurança duplo (MFA)',
        messageMFA:
          'Você não tem o fator de segurança duplo (MFA) habilitado para executar a ação'
      }
    },
    first_login_terms_conditions: 'Acepto los Términos y Condiciones',
    ob_project: 'OnBoarding',
    ob_info_employee: 'Información para el empleado',
    ob_title: 'Configuração OnBoarding',
    ob_title_list: 'Formas de Onboarding',
    ob_welcome_message: 'Mensaje de Bienvenida',
    ob_search_title: 'Funcionários',
    ob_select: 'Seleccione',
    ob_select_template: 'Seleccione un template',
    ob_title_model_list: 'Modelo de organización',
    ob_select_model_organization: 'Seleccione el modelo de organización',
    ob_name: 'OnBoarding nome',
    ob_not_completed: 'Onboarding',
    ob_not_started: 'Onboarding',
    ob_create_template: 'Novo modelo',
    ob_documents: 'Documentos',
    ob_load_employees: 'Carga de empleado',
    ob_masive_load_employees: 'Agregar empleados',
    ob_submit_swal_confirm: 'Activar',
    ob_submit_swal_reject: 'Cancelar',
    ob_submit_swal_got_it: 'Entendido',
    ob_submit_swal_text:
      'Una vez dado de alta no se pueden devolver los cambios!',
    ob_submit_swal_title: 'Desea dar de alta el Onboarding?',
    ob_submit_massive_swal_title:
      '¿Desea dar de alta a los empleados seleccionados?',
    ob_submit_swal_title_eactivate: '¿Desea dar de alta al empleado?',
    ob_sujet: 'Asunto',
    ob_started: 'Onboarding',
    ob_template_digital: 'Template Formulario Digital',
    ob_destination_folder: 'Carpeta de destino',
    ob_destination_folder_visible: 'Visible para el empleado',
    ob_destination_folder_notvisible: 'No visible para el empleado',
    ob_change_template_tooltip: 'Cambiar Plantilla On-boarding',
    ob_destination_folder_warning: 'Debe seleccionar una carpeta de destino',
    ob_reactivate_user: 'Reativar funcionário',
    ob_reactivate_user_with_license:
      'Você precisará ativar o módulo de licença manualmente na guia "Configuração", se desejar.',
    ob_reactive_user_not_date: 'Você precisa inserir a data de entrada',
    ob_reactivate_user_success: 'O funcionário foi reativado com sucesso',
    ob_reactivate_user_date_note:
      'Info: La fecha a ingresar debe ser mayor a la fecha de baja legal',
    ob_send_notification: 'Enviar lembrete de documentos ausentes',
    ob_send_notification_body:
      'Um e-mail será enviado para os funcionários selecionados integrando que não possuem nenhum documento obrigatório para concluir',
    ob_send_notification_response: 'Detalhe da entrega do lembrete',
    ob_massive_general_error_response:
      'Algunos empleados no se pudieron activar correctamente',
    ob_reactive_user_email_exists:
      'El email que ingresó ya se encuentra en uso',
    change_image_swal_confirm: 'Si',
    change_image_swal_error: 'Ups ha ocurrido un error!',
    change_image_swal_deleted: 'Imagen eliminada',
    change_image_swal_rejct: 'No',
    change_image_swal_text: 'No es posible revertir esta acción!',
    change_image_swal_title: '¿Estas seguro?',
    ei_title: 'Informação do Empregado',
    ei_personal_info_title: 'Informação do Empregado',
    ei_personal_info_edit: 'Editar',
    ei_personal_send_menssage: 'Enviar mensaje',
    ei_personal_change_password: 'Cambiar contraseña',
    ei_personal_download_file: 'Descargar legajo',
    ei_personal_employee_configuration: 'Configuración empleado',
    ei_personal_employee_suspend: 'Suspender empleado',
    ei_personal_employee_unlink: 'Desvincular empleado',
    ei_personal_employee_change_template: 'Cambiar Plantilla On-boarding',
    ei_personal_info_save_changes: 'Guardar mudanças',
    ei_personal_options_button: 'Más opciones',
    ei_personal_data_title: 'Documentação Pessoal',
    ei_familiares_title: 'Sección Parientes',
    ei_personal_formDigital_title: 'Formularios Digitales',
    ei_OnboardingComplete: 'Completo',
    ei_OnboardingIncomplete: 'Incompleto',
    ei_ActiveButton: 'Ativar',
    ei_ActiveEmployee: 'Empleado Activo',
    ei_InactiveEmployee: 'Empleado Inativo',
    ei_RefuseImg: 'RechazaOo Imagen',
    ei_titleList_text_1: 'Informação pessoal',
    ei_titleList_text_2: 'Documentos pessoais',
    ei_titleList_text_3: 'Digital Form',
    ei_titleList_text_4: 'Grupo Familiar',
    ei_titleList_text_5: 'Informação bancária',
    ei_titleList_text_6: 'Dados pessoais',
    ei_titleList_text_1_1: 'Nome *',
    ei_titleList_text_1_2: 'Sobrenome *',
    ei_titleList_text_1_3: 'Documento de identidade *',
    ei_titleList_text_1_4: 'CPF',
    ei_titleList_text_1_5: 'Sex',
    ei_titleList_text_1_6: 'Data de início *',
    ei_titleList_text_1_7: 'File *',
    ei_titleList_text_1_8: 'Data de início *',
    ei_titleList_text_2_1: 'Celular',
    ei_titleList_text_2_2: 'Email',
    ei_titleList_text_3_1: 'Street',
    ei_titleList_text_3_2: 'Number',
    ei_titleList_text_3_3: 'Country',
    ei_titleList_text_3_4: 'Estado',
    ei_titleList_text_3_5: 'City',
    ei_titleList_text_3_6: 'Localização',
    ei_titleList_text_4_1: 'Cônjuge',
    ei_titleList_text_4_2: 'Número de filhos',
    ei_titleList_text_5_1: 'Banco',
    ei_titleList_text_5_2: 'CBU',
    ei_titleList_text_5_3: 'Número da conta',
    ei_complete: 'Completo',
    ei_incomplete: 'Não completo',
    ei_apply: 'Não se aplica',
    ei_image_not_available: 'Imagen no disponible',
    ei_photo_not_found: 'Imagen no encontrada',
    ei_description:
      '(*) Corresponde a informações fornecidas pela área de Recursos Humanos',
    error_50001: 'O nome do modelo é obrigatório',
    error_50002: 'Ocurrió un error al modificar el usuario',
    error_50004: 'Nenhum documento encontrado',
    error_50005: 'Invalid template name',
    error_50006: 'Parâmetros incorretos',
    error_00217:
      'Error al obtener el archivo previamente agregado durante el onboarding',
    error_50010_1: 'No fue posible procesar el archivo',
    error_50010_2:
      'El archivo cargado excede la cantidad máxima de páginas permitidas',
    error_00002: 'Ocorreu um erro na conexão',
    error_00004: 'No se han podido guardar los cambios',
    error_401: 'Você deve logar novamente',
    error_00018: 'usuário bloqueado',
    error_04744:
      'Usuário bloqueado por falta de pagamento, entre em contato com a área financeira da VISMA em servicios.zetech@visma.com',
    error_50013: 'La URL ingresada no es un video.',
    error_05009: 'A data de entrada é inválida.',
    error_05006:
      'La fecha de contratación no puede ser menor a la fecha de nacimiento',
    error_05007:
      'Debe existir una diferencia mayor a 17 años entre la fecha de contratacion y la fecha de nacimiento',
    error_05008:
      'Ha ocurrido un error reactivando al usuario, por favor contacte a soporte',
    error_05005: 'El empleado no se encuentra en un status de inactivo.',
    error_05143:
      'La fecha de ingreso debe ser mayor a la fecha de baja legal (ver info en el ícono del motivo de baja)',
    error_05144:
      'La fecha de baja no tiene un formato de fecha válido (dd/mm/aaaa)',
    error_05103:
      'La fecha de ingreso no tiene un formato de fecha válido (dd/mm/aaaa)',
    error_50044: 'A mensagem de boas-vindas não suporta caracteres especiais',
    error_not_onboarding:
      'Usuario en proceso de Onboarding, para continuar debe finalizar el mismo desde',
    error_rrhh: 'Debe ser de RRHH para acceder',
    error_20001: 'El modelo de organización debe ser numérico',
    error_20002: 'El modelo de organización enviado no es un valor válido',
    error_20003: 'No fue posible actualizar el modelo de organización',
    form_select: 'Seleccione...',
    title_popover_first_login: 'A senha deve conter:',
    msj_success_title_list: 'Feito',
    msj_success_list: 'O modelo foi ativado corretamente',
    msj_success_modify_user: 'El usuario ha sido modificado exitosamente',
    msj_warning_edit: 'Advertencia',
    msj_warning_edit_date:
      'Es necesario que ingrese "Fecha de ingreso primero.',
    msj_success_edit: 'modelo modificado corretamente',
    msj_warning_title_list: 'Atenção',
    msj_warning_list: 'O modelo foi desativado',
    msj_incomplete:
      'Não foi possível salvar as alterações. É obrigatório selecionar pelo menos um item das seções "Informações Pessoais", "Documentos Pessoais" e "Documentos".',
    msj_typeImg: 'el tipo de imagen tiene que ser JPG o PNG',
    msj_sizeImg: 'La imagen debe ser menor de 5 MB',
    head_text_table_list_1: 'Nome',
    head_text_table_list_2: 'Última modificação',
    head_text_table_list_3: 'Estado',
    head_text_table_search_1: 'Nome e sobrenome',
    head_text_table_search_2: 'e-mail',
    head_text_table_search_3: 'ID',
    head_text_table_search_4: 'Arquivo',
    head_text_table_search_5: 'Estado',
    head_text_table_search_6: 'Data de contratação',
    text_table_status_1: 'Ativar',
    text_table_status_2: 'Desativar',
    head_text_document_1: 'Dados',
    head_text_document_2: 'Image',
    head_text_document_3: 'Obrigatório',
    employees_title: 'Gestión de empleados',
    employees_list_result: 'Lista de funcionários',
    employees_list_search_title_error: 'Isto é um deserto!',
    employees_list_search_desc_error:
      'Lamentamos, mas não encontramos nenhum resultado com os critérios de pesquisa selecionados.Por favor, tente uma combinação diferente.',
    employees_list_search_title:
      'Os resultados da sua pesquisa serão exibidos aqui.',
    employees_list_search_desc:
      'Para realizar uma pesquisa, você pode inserir o Nome, Sobrenome, DNI ou E- mail do funcionário no campo de pesquisa ou selecionar uma combinação de filtros.',
    employees_list_modal_folder_title: 'Permissões de pasta',
    employees_list_modal_folder_subtitle: 'Pastas atribuídas',
    employees_list_modal_folder_empty: 'Não há pastas atribuídas',
    employees_list_modal_swal_correct: 'Pastas atribuídas com sucesso',
    employees_list_modal_swal_incorrect:
      'As pastas não foram carregadas corretamente, tente novamente',
    employees_list_modal_reset_pass_correct: 'Correio Enviado',
    employees_list_modal_reset_pass_incorrect: 'Erro ao enviar e-mail',
    employees_list_modal_reset_pass_incorrect_change:
      'Erro ao alterar o correio',
    search_folder_placeholder: 'Não há mais pastas',
    employees_list_modal_reset_subtitle:
      'Um link será enviado ao usuário para redefinir a senha',
    employee_export_results: 'Exportar Resultados',
    employee_exporting_results: 'Exportando...',
    employee_activate_selection: 'Activar Selección',
    employee_result: 'Resultados',
    employee_confirm: 'Aceptar',
    employee_edit_error: 'Algo falló!',
    employee_edit_success: 'Usuario modificado exitosamente',
    employee_alert_selection: 'Lembrete',
    ob_activated_swal_title: 'Buen trabajo!',
    ob_activated_swal_text: 'Se han activado los onboarding!',
    ob_body: 'Cuerpo',
    ob_completed: 'Onboarding',
    search_text_select_locacion: 'TODOS',
    search_text_select_sector: 'TODOS',
    search_text_select_centroDeCostos: 'TODOS',
    search_text_select_cargo: 'TODOS',
    search_text_1: 'Pesquisar por:',
    search_text_1_1: 'Dni, nome, sobrenome ou e-mail',
    search_text_1_2: 'Arquivo',
    search_text_1_3: 'Busca avançada',
    search_text_2: 'Status do funcionário',
    search_text_2_1: 'Onboarding',
    search_text_2_2: 'Ativo',
    search_text_2_3: 'Inativo',
    search_text_3: 'Tipo de perfil',
    search_text_3_1: 'RRHH',
    search_text_3_2: 'Empregado',
    search_text_4: 'Setor',
    search_text_5: 'Localização',
    search_text_6: 'Módulo de licença',
    search_text_6_1: 'Aprovador',
    search_text_7: 'Renda',
    search_text_7_1: 'Eles não entraram',
    search_text_8: 'Setor y Localização',
    search_text_9: 'Selecionado',
    search_text_10: 'Fecha de contratación',
    search_text_11: 'Fecha de desvinculación',
    search_text_12: 'Centro de costos',
    search_text_date_placeholder: 'Selecione un rango de fecha',
    search_folder_tooltip: 'Configurar pastas',
    search_reset_pass_tooltip: 'Redefinir senha',
    checkbox_reset_pass_tooltip: 'Gere uma senha automaticamente',
    save: 'Salve modelo',
    action_save_template_text: '¡Criado com sucesso!',
    edit: 'Edite',
    return: 'Voltar',
    cancel: 'Cancelar',
    search: 'Critérios de pesquisa',
    searchfor: 'Pesquisar',
    home: 'Inicio',
    menu_1: 'Funcionários',
    menu_2: 'Arquivos',
    menu_3: 'licenças',
    menu_4: 'negócios',
    menu_5: 'reportar',
    menu_6: 'Configuración OnBoarding',
    menu_7: 'Legajo digital',
    menu_8: 'Vacaciones y licencias',
    menu_1_1: 'Administrador de Empregados',
    menu_1_2: 'Veja o detalhe do documento',
    menu_1_3: 'Visualizador de Auditoria',
    menu_1_4: 'Carga em Massa de Empregados',
    menu_1_5: 'Lembrete Funcionários',
    menu_1_6: 'Carga Individual de Empleado',
    menu_1_7: 'Baja masiva de empleados',
    menu_2_1: 'Publicación de Documentos',
    menu_2_1_1: 'Publicação maciça',
    menu_2_1_2: 'Publicação Individual',
    menu_2_1_3: 'Publicação de Documentos sem Código',
    menu_2_1_4: 'Gestion das Publicações',
    menu_2_1_5: 'Buscador de Documentos',
    menu_2_1_6: 'Estado de procesos',
    menu_2_2: 'Formulários Digitais',
    menu_2_2_1: 'Faça Publicação',
    menu_2_2_2: 'Publicações Feitas',
    menu_2_2_3: 'Modelos',
    menu_2_2_4: 'Plantillas de Formularios Digitales',
    menu_2_3: 'Buscador de documentos',
    menu_3_1: 'Gestão de Licenças',
    menu_3_2: 'Solicitudes',
    menu_4_2: 'Cartelera de noticias',
    menu_4_3: 'Auditoria',
    menu_4_4: 'Configuración',
    menu_4_5: 'Configuración de carpetas',
    menu_4_6: 'Centro de seguridad',
    menu_4_7: 'Certificados de firma electrónica',
    login_text_about_us: 'Sobre nós',
    login_text_button: 'Entrar',
    login_text_contact: 'Contato',
    login_text_forgot_password: 'Esqueceu sua senha?',
    login_text_language: 'Língua:',
    login_text_password: 'Senha',
    login_text_user: 'Usuário',
    login_faq_title: 'Preguntas Frecuentes',
    login_faq_one: 'No puedo acceder a la plataforma para ver mi recibo',
    login_faq_one_answer:
      "TURECIBO.COM permite una autogestión, mediante la opción 'olvidé mi clave de acceso'. El sistema enviará al correo electrónico registrado en el sistema las indicaciones para regenerar clave de ingreso o clave de firma. En caso que no te llegue el mail para restablecerla, debes ponerte en contacto con el departamento de Recursos Humanos de tu Empresa quienes podrás asistirte para recuperarla",
    login_faq_two: '¿Cómo puedo desbloquear el usuario?',
    login_faq_two_answer:
      "Luego de varios intentos fallidos para ingresar a la plataforma, por seguridad, el sistema bloqueará el usuario. Para desbloquearlo simplemente debes ingresar a la opción 'Olvidó su contraseña' e ingresar el mail registrado en el sistema y su DNI. En caso de no poder restablecerlo debe ponerse en contacto con departamento de Recursos Humanos de tu Empresa quienes podrás asistirte para desbloquear el usuario",
    login_faq_three: '¿Es seguro el sistema?',
    login_faq_three_answer:
      'Sí, el mismo ha sido testeado con los mas rigurosos métodos de seguridad informática, y la comunicación se realiza de manera encriptada utilizando el protocolo https, el mismo utilizado por los bancos, tarjetas de crédito, sitios de pagos por Internet, etc.',
    login_faq_close_button_text: 'Cerrar',
    login_need_help: '¿Necesitas Ayuda?',
    login_mail:
      'El email informado es utilizado para facilitar la recuperación de la clave y la notificación de un recibo nuevo. Es muy importante que ingrese una cuenta.',
    login_first_login_title: 'Primer Ingreso',
    login_first_login_subtitle:
      'Por razones de seguridad debe cambiar su clave de ingreso al sistema',
    login_first_login_password_field_label: 'Nova senha',
    login_first_login_repeat_password_field_label: 'Confirme nova senha',
    confirm_password: 'Redigite a senha',
    login_first_login_no_email_label: 'No poseo cuenta de email',
    login_first_login_email_field_help_text:
      'Recuerde ingresar un email válido, ya que será verificado durante el proceso',
    login_first_login_required_field: 'Este campo es requerido',
    login_commercial_info: 'Información Comercial',
    login_welcome_title:
      'Gerencie as informações e a documentação do seu equipamento onde e quando quiser',
    login_welcome_subtitle:
      'Ahorre tiempo y dinero con la Gestión Digital de los Documentos de Recursos Humanos',
    login_send: 'Enviar',
    login_go_back: 'Volver',
    login_request_password_title: 'Recupero de Contraseña',
    login_jwt_expired: 'Su sesión ha expirado.',
    footer_privacy_policy: 'Políticas de privacidad',
    footer_public_certificate: 'Certificado público de turecibo.com',
    product_name: 'Tu Recibo',
    header_top_bar_change_company: 'Cambiar empresa',
    header_top_bar_edit_password: 'Editar clave',
    header_top_bar_edit_email: 'Editar email',
    header_top_bar_logout: 'Salir',
    header_top_bar_modal_save: 'Guardar',
    header_top_bar_new_mail: 'Email nuevo',
    header_top_bar_password_changed_message:
      'Su clave ha sido cambiada con exito.',
    header_top_bar_accept_button_text: 'Aceptar',
    header_top_bar_mail_changed_message: 'Su email ha sido cambiado con exito.',
    header_top_bar_change_company_text: 'Cambiar empresa',
    header_top_bar_change_avatar_text: 'Cambiar Avatar',
    home_button_publish: 'Publicar Documentos',
    home_button_main:
      'Aquí encontrarás los accesos más frecuentes para que puedas agilizar tu tiempo dentro de la plataforma.',
    home_button_add: 'Administrar Empleados',
    home_create_users: 'Agregar empleados',
    home_button_adm_users: 'Administrador de empleados',
    home_button_search_users: 'Gestión de publicaciones',
    home_adm_publish: 'Administrador de procesos',
    home_button_reports: 'Gestión de reportes',
    home_welcome_again: 'Bienvenido',
    home_button_publish_news: 'Publicar noticia',
    switch_user_company_text: 'Empresa',
    switch_user_profile_text: 'Perfil',
    switch_user_status: 'Estado',
    switch_user_profile_employee: 'Empleado',
    switch_user_profile_rrhh: 'Recursos Humanos',
    swal_error: 'Ha ocurrido un error!',
    title_404: 'Desculpe, mas a página não foi encontrada',
    sub_title_404: 'Felizmente, você pode voltar para a pesquisa em casa',
    btn_text_back_to_home: 'De volta para casa',
    title_403: 'Lo sentimos, pero usted no tiene acceso a esta página',
    sub_title_403:
      'SI usted no es administrador puede ir al sitio de empleado o volver al home',
    yes_logout_text: 'Si',
    not_logout_text: 'No',
    headerInfoPersonal: 'Información Personal',
    headerDocPers: 'Documentos Personales',
    confirm_delete_img_text: 'Esta seguro que desea elimina la imagen?',
    header_logout: 'Aviso',
    downloadDocument: 'Baixar Documento',
    textNoOnboarding: 'Este empleado no paso por un proceso de Onboarding',
    error_eForms:
      'No es posible conectarse con el modulo de eForms, aguarde o póngase en contacto con el proveedor',
    header_top_bar_modal_change_button: 'Cambiar',
    copyrightText: 'Copyright',
    err_title: 'El nombre del template es obligatorio',
    err_infoPersonal:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Información personal"',
    err_docPersonales:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Documentos Personales"',
    err_eF:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Documentos"',
    err_img:
      'No fue posible guardar los cambios. Es obligatorio subir una imagen',
    err_video:
      'No fue posible guardar los cambios. Usted seleccionó "Video institucional", es obligatorio escribir una url',
    billboard_form_header_create_title: 'Nueva Publicación',
    billboard_form_header_edit_title: 'Editar Publicación',
    billboard_form_content_validator_message:
      'Debe ingresar al menos un contenido de texto, imagen o video',
    billboard_form_submit_button_text: 'Publicar',
    billboard_form_cancel_button_text: 'Cancelar',
    billboard_form_post_preview_text: 'Previsualizar',
    billboard_form_post_details_text: 'Detalles de la publicación',
    billboard_form_post_sectors_text: 'Sectores',
    billboard_form_post_locations_text: 'Locaciones',
    billboard_form_post_recipients_text: 'Destinatarios',
    billboard_form_post_input_valid_from_placeholder: 'Válida desde',
    billboard_form_post_input_valid_to_placeholder: 'Válida hasta',
    billboard_form_post_update_success_text: 'Publicación actualizada.',
    billboard_form_post_button_confirm: 'Aceptar',
    billboard_form_post_create_success_text: 'Publicación realizada.',
    billboard_form_dates_validator_message:
      'La fecha de expiración de la publicación debe ser mayor a la fecha de inicio',
    billboard_form_textarea: 'Mensagem',
    billboard_form_videos_validator_message:
      'Sólo se admiten videos de vimeo o youtube',
    billboard_list_delete_success_message: 'Notificación eliminada.',
    billboard_list_header_title: 'Publicaciones recientes',
    billboard_list_grid_title_column: 'Título de la publicación',
    billboard_list_grid_valid_from_column: 'Válido desde',
    billboard_list_grid_valid_to_column: 'Válido hasta',
    billboard_list_grid_author_column: 'Autor',
    billboard_list_grid_state_column: 'Estado publicación',
    billboard_list_grid_active_state_text: 'Activa',
    billboard_list_grid_inactive_state_text: 'Inactiva',
    billboard_summary_posts_title: 'Publicaciones',
    billboard_list_delete_confirm_message_title:
      '¿Está seguro de borrar la notificación?',
    billboard_list_delete_confirm_message_subtitle:
      'Una vez realizada esta operación no se podrá deshacer',
    billboard_list_delete_confirm_button_text: 'Si',
    billboard_list_delete_cancel_button_text: 'No',
    billboard_create_button_text: 'Nueva publicación',
    billboard_page_title: 'Cartelera de noticias',
    billboard_title_invalid: 'Um texto inválido foi inserido',
    text_eform_not_found: 'No has creado ningun formulario',
    billboard_modal_preview_title: 'Previsualización',
    billboard_lazy_loading_text: 'Cargando ...',
    onboarding_empty_1: 'Parece que no existen templates creados',
    onboarding_empty_2:
      'Al crear un template de onboarding usted podra configurar los distintos procesos admisión que deberan completar sus futuros empleados',
    billboard_loading_text: 'Publicando ...',
    billboard_empty_location_and_sector_text:
      'Debe ingresar al menos una locación y un sector',
    billboard_forbidden_file_type_text: 'Formato de archivo no compatible',
    onboarding_label_by_page: 'Mostrar',
    uploadImageComponent: {
      header: {
        titleHeader: 'Bandeja de tareas',
        subtitleHeader1: 'Inicio'
      },
      topBar: {
        approveButton: 'Aprobar',
        rejectButton: 'Rechazar'
      },
      modals: {
        fileUploadVisualizerTitle: 'Visualización de documento',
        individualErrorModalTitle: 'Problema al procesar el documento',
        individualRejectModalTitle: 'Motivo de rechazo',
        individualRejectWarning: 'Estás a punto de rechazar este documento',
        individualRejectWarning2: 'Esta acción no se puede deshacer',
        individualRejectPlaceholderTextArea:
          'Ingresa el motivo de rechazo del documento',
        individualRejectSuccessfulModalTitle: 'Documento rechazado',
        individualRejectDocumentRejected: 'Documento rechazado',
        individualRejectInfo: 'Rechazaste el ',
        multipleRejectWarning: 'Estás a punto de rechazar {input} documentos',
        multipleRejectPlaceholderTextArea:
          'Ingresa el motivo de rechazo de los documentos',
        multipleApproveModalTitle: 'Aprobar seleccionados',
        multipleApproveConfirm:
          '¿Estás seguro de querer <strong>Aprobar</strong> los <strong>{input} elementos seleccionados</strong> de tu bandeja de tareas?',
        multipleApproveWarning: 'Esta acción no se puede deshacer',
        multipleRejectDocumentRejected: 'Documentos rechazados',
        buttonApprove: 'Aprobarlos',
        buttonApproveLoading: 'Aprobando...',
        buttonReject: 'Rechazar',
        buttonRejectLoading: 'Rechazando...',
        buttonCancel: 'Cancelar',
        individualError:
          'Ocurrió un error al procesar el documento, por favor vuelva a intentarlo',
        pleaseWait: 'Si el problema persiste aguarde unos minutos',
        buttonUnderstand: 'Entendido',
        multipleApproveSuccess: 'Documentos aprobados',
        xDocumentsApproved: '{quantity} Registros aprobados',
        handledErrorsModalTitle: 'Problema al procesar el documento',
        handledErrorsMessage:
          'Ocurrió un error con los siguientes {quantity} documentos de tu selección',
        buttonRetry: 'Reintentar',
        buttonRetryLoading: 'Reintentando...'
      },
      body: {
        noPendingTasks: {
          title: 'No hay documentos en tu bandeja de tareas',
          content: 'Relájate y disfruta el momento'
        },
        leftContainer: {
          filter: {
            searchFilter: 'Filtros de búsqueda',
            inputPlaceholder:
              'Nombre, apellido, identificador único, fecha, sector y locación',
            inputBaseMessage:
              'Buscar por Nombre, Apellido, Identificador único',
            SelectOption: 'Ordenar por:',
            allFiltersOn: 'Todos',
            date: 'Fecha',
            documentType: 'Tipo de documento',
            name: 'Nombre',
            cuil: 'Cuil',
            sector: 'Sector',
            time: 'Hora',
            orderBy: 'Ordenado por:',
            locacion: 'Locación',
            document: 'Tipo de documento',
            asc: 'Ascendente',
            desc: 'Descendente'
          },
          multipleSelection: {
            oneSelectedItem: '1 seleccionado',
            xSelectedItems: '{quantity} seleccionados',
            selectAll: 'Seleccionar los otros {total} registros'
          },
          singleApprove: {
            questionApprove: '¿Está seguro/a que desea aprobar el documento?',
            singleApproveSuccess: 'El documento ha sido aprobado',
            singleApproveError: 'Hubo un error al aprobar el documento'
          },
          singleDeny: {
            denySingle: 'Rechazo de documento',
            questionDeny: '¿Está seguro/a que desea rechazar el documento?',
            singleDenySuccess: 'El documento ha sido rechazado',
            singleDenyError: 'Hubo un error al rechazar el documento'
          },
          massiveApprove: {
            buttonApproveAll: 'Aprobación Masiva',
            questionMassiveApprove:
              '¿Está seguro/a que desea aprobar masivamente los documentos seleccionados?',
            massiveApproveSuccess: 'Los documentos han sido aprobados',
            massiveApproveError:
              'hubo un error al aprobar masivamente los documentos'
          },
          massiveDeny: {
            buttonDenyAll: 'Rechazo Masivo',
            denyAll: 'Rechazo Masivo de documentos',
            denyAllText:
              'El rechazo del documento envia un mail notificando al empleado.',
            denyAllPlaceholder: 'Describa el motivo de rechazo',
            questionMassiveDeny:
              '¿Está seguro/a que desea rechazar masivamente los documentos seleccionados?',
            massiveDenySuccess: 'Los documentos han sido rechazados',
            massiveDenyError:
              'Hubo un error al rechazar masivamente los documentos'
          },
          generalErrors: {
            errorOnSubmit: 'Hubo un error',
            errorOnLoadCards:
              'Hubo un error en mostrar las cargas pendientes de los usuarios'
          },
          noMoreResults: 'No hay más resultados',
          noMoreSearchingFromUser: 'No hay tareas que coincidan con tu búsqueda'
        },
        rightContainer: {
          noContentEmptyState: {
            title: 'Aquí se visualizarán los tipos de documentos',
            content:
              'Puedes elegir multiples documentos y aprobarlos o rechazarlos masivamente'
          },
          employeeInfo: {
            attaches: 'Adjuntos',
            dontHaveIt: 'No tiene',
            pages: 'Página'
          },
          image: {
            problemWithImage:
              'Hubo un problema al cargar la imagen, por favor consulte con soporte',
            page: 'Página',
            loading: 'Cargando documento'
          },
          multipleSelection: 'Selección múltiple de documentos'
        },
        noContentEmployeeInfo: {
          noSector: 'No posee sector',
          noLocacion: 'No posee locación',
          noCuil: 'No posee Cuil',
          noArchiveName: 'Sin nombre de carga',
          noDate: 'No posee fecha'
        },
        swalButtons: {
          cancel: 'No',
          accept: 'Aceptar',
          approve: 'Si',
          deny: 'Si'
        }
      },
      errorLogs: {
        '04002':
          'El empleado no pertenece a la empresa a la del usuario que subio el documento',
        '04003': 'Formato invalido',
        '04004': 'El PDF no puede exceder el total de páginas permitidas',
        '04005': 'Error al cargar el archivo',
        '04006': 'El campo nombre es requerido',
        '04007': 'El campo template es requerido',
        '04008': 'No eres administrador',
        '04009': 'El campo nombre es requerido',
        '04010': 'El campo Json es requerido',
        '04011': 'No se pudo obtener el usuario',
        '04012': 'No tienes permiso para realizar esta acción',
        '04013': 'El parámetro Id_type_document es requerido',
        '04014': 'El parámetro Template es requerido',
        '04015': 'El parámetro Files es requerido',
        '04016': 'El usuario no posee el action profile requerido',
        '04018': 'La cantidad de archivos subidos es incorrecta',
        '04019': 'El campo de valor es requerido',
        '04020': 'El Id_type_documen no pertenece a la compañia',
        '04021': 'Formato del Json invalido',
        '04022': 'Se debe agregar parametros junto al Json',
        '04023': 'Los parámetros adentro del Json son incorrectos',
        '04024':
          'El empleado no pertenece al sector del usuario que subio el documento',
        '04025':
          'El empleado no pertenece a la locacion del usuario que subio el documento',
        '04026': 'El documento debe estar en estado inicial',
        '04027': 'El status fue cambiado con éxito',
        '04028': 'Error al actualizar la base de datos',
        '04029': 'El status fue cambiado con éxito',
        '04030': 'El parámetro País no es correcto',
        '04031': 'El parámetro compañia no es correcto',
        '04032': 'El ID de la empresa debe ser numérico',
        '04033': 'El ID del país debe ser numérico',
        '04034': 'El ID es requerido',
        '04035': 'El nombre es requerido',
        '04036': 'El formato del archivo es incorrecto',
        '04037': 'El ID es incorrecto',
        '04038': 'El ID no pertenece a la carga del usuario',
        '04039': 'La carga del archivo falló',
        '04040': 'Nombre incorrecto.',
        '04041': 'Error al actualizar el template',
        '04042': 'Ya se completo la carga maxima de archivos',
        '04043': 'No puedes ver documentos de otras compañías',
        '04044': 'El campo hash es requerido',
        '04045': 'Los hash no coinciden',
        '04046': 'No se pudo crear el directio correctamente',
        '04047': 'El documento no existe',
        '04048': 'Error al unir archivos',
        '04049': 'El archivo excede el tamaño máximo',
        '04051': 'No se puede leer el archivo PDF',
        '05000': 'Desconocido',
        '05101': 'Licencias progresivas no tiene un valor válido',
        '05102': 'La fecha de nacimiento no tiene un fecha válida',
        '05103': 'La fecha de contratación no tiene un fecha válida',
        '05104': 'La fecha de contratación no tiene un fecha válida',
        '05105': 'El legajo no es número entero válido',
        '05106':
          'Niveles de aprobación de licencias progresivas no tiene un fecha válida',
        '05107': 'El número de legajo de aprobador no es número entero válido',
        '05108':
          'La antigüedad previa de licencias progresivas no es número entero válido',
        '05109':
          'El ID de políticas de licencias progresivas no es número entero válido',
        '05110': 'El ID de la empresa es requerido',
        '05111': 'El usuario es requerido',
        '05112': 'El nombre es requerido',
        '05113': 'El apellido es requerido',
        '05114': 'El DNI es requerido',
        '05115': 'El CUIL es requerido',
        '05116':
          'El nombre debe contener entre 1 y 50 caracteres alfanuméricos',
        '05117':
          'El apellido debe contener entre 1 y 50 caracteres alfanuméricos',
        '05118': 'El mail no tiene un formato válido',
        '05119':
          'El usuario debe contener entre 1 y 32 caracteres alfanuméricos, incluidos caracteres alfanuméricos, dígitos y guiones bajos',
        '05120':
          'El dni debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas',
        '05121':
          'El cuil debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas',
        '05122':
          'El sector debe ser alfanumérico con barras, espacios y/o comas y no debe exceder los 250 caracteres',
        '05123':
          'La locación debe ser alfanumérico con barras, espacios y/o comas y no debe exceder los 250 caracteres',
        '05124': 'El usuario es duplicado',
        '05125': 'El mail es duplicado',
        '05126': 'El dni es duplicado',
        '05127': 'El cuil es duplicado',
        '05128':
          'La fecha de nacimiento no puede ser una fecha posterior a hoy',
        '05129': 'La fecha de nacimiento denota un empleado menor de edad',
        '05130':
          'La fecha de contratación no debe superar los 40 días a partir de hoy',
        '05131':
          'La fecha de nacimiento debe ser superior a la fecha de contratación',
        '05132':
          'Debe haber una diferencia de 14 años entre la fecha de nacimiento y la fecha de contratación',
        '05133': 'El legajo es duplicado',
        '05134': 'La contraseña o el mail son requeridos',
        '05135': 'La clave debe tener al menos 8 caracteres',
        '05136': 'Saltear el mail de bienvenida no tiene un valor válido',
        '05137':
          'El cambio del valor puede desvincular las publicaciones de documentos del usuario',
        '05138':
          'El cambio del valor puede invalidar la contraseña, debes resetearla',
        '05139':
          'La fecha de contratación es obligatoria y no se puede modificar',
        '05140':
          'No se ha podido actualizar el número de legajo ya que es aprobador de otro empleado.',
        '05141': 'La fecha de contratación del usuario es requerida'
      }
    },
    text_mask_character: '(máximo 140 caracteres)',
    crossSelling: {
      digitalFile: {
        landing: {
          title: '¿Qué puedes realizar en legajo digital?',
          item_1: 'Tener una experiencia de OnBoarding 100% digital',
          item_2: 'Completar y firmar todos los documentos de ingreso',
          item_3:
            'Presentar toda la documentación requerida en formato digital',
          item_4: 'Conocer a su equipo de trabajo',
          item_5: 'Tener las respuestas a sus preguntas frecuentes',
          buttonDefault: 'Quiero más información',
          buttonSent: 'Solicitud enviada'
        },
        toaster: {
          title: 'Legajo Digital información',
          containerText:
            'Hola {nombre}! Muchas gracias por contactarte con nosotros. Un asesor comercial te contactará en las próximas 24-48hs para brindarte la información que solicitaste.',
          button: 'Entendido'
        }
      },
      licenses: {
        landing: {
          title: '¿Qué puedes realizar en Vacaciones & Licencias?',
          item_1:
            'Los empleados podrán solicitar vía mobile o desktop vacaciones y licencias',
          item_2: 'Podrás aprobar o rechazar solicitudes pendientes',
          item_3:
            'Tendrás un potente reporte de saldos y buscador de solicitudes pasadas',
          item_4: 'Flujo de aprobadores por niveles',
          item_5: 'Adaptable a los convenios y regulaciones de tu país',
          buttonDefault: 'Quiero más información',
          buttonSent: 'Solicitud enviada'
        },
        toaster: {
          title: 'Vacaciones y licencias información',
          containerText:
            'Hola {nombre}! Muchas gracias por contactarte con nosotros. Un asesor comercial te contactará en las próximas 24-48hs para brindarte la información que solicitaste.',
          button: 'Entendido'
        }
      }
    },
    documentSearch: {
      searchTitlePreview: 'Vista previa del documento',
      searchDownloadText: 'Descargando...'
    },
    profileModals: {
      switchCompany: {
        current: 'Actual',
        profile: 'Perfil',
        myCompanies: 'Mis empresas',
        change: 'Cambiar',
        ipRestricted: 'Restringido por IP'
      },
      editPass: {
        title: 'Cambia tu clave de acceso',
        currentPass: 'Ingrese clave actual',
        newPass: 'Ingrese nueva clave',
        repeatPass: 'Repita nueva clave',
        notSamePass: 'Las contraseñas no coinciden'
      },
      editMail: {
        title: 'Cambia tu email personal',
        currentMail: 'Tu correo electrónico actual asociado es',
        inputsTitle: 'Introduce un correo electronico nuevo y tu clave actual',
        newMail: 'Correo electrónico nuevo',
        password: 'Clave actual'
      },
      save: 'Guardar',
      cancel: 'Cancelar'
    },
    vismaIntegrations: {
      vismaCommunityWidget: {
        title: 'Últimas notícias',
        noContent: 'Sem notícias',
        viewMore: 'Veja mais notícias'
      },
      homeDashboard: {
        title: 'Novedades en nuestros productos',
        info: 'Ingresa a <b>Visma Community</b> y descubre toda la información del software, HR y mucho más.',
        confirm_btn: 'Ir a Visma Community'
      },
      activateOnboarding: {
        ob_massive_download_csv:
          'Descargue el listado de errores para identificar a los empleados afectados',
        dowload_btn: 'Descargar',
        cancel_btn: 'Cancelar',
        errorIE:
          'Esta funcionalidad no está soportada en IE, por favor utilice otro navegador',
        errors: {
          generic:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos'
        },
        success: {
          title: 'Empleado activado con observaciones',
          info: 'Se creó el usuario en Visma People pero con errores en alguno de sus campos. Puede terminar de completar la información dentro de Visma People.'
        },
        validations: {
          modal_title: 'Los siguientes campos son obligatorios',
          modal_subtitle:
            'No podrá activar el empleado hasta que el mismo complete la siguiente información',
          VP_FIRSTNAME_IS_REQUIRED: 'Nombre',
          VP_LASTNAME_IS_REQUIRED: 'Apellido',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidad',
          VP_GENRE_IS_REQUIRED: 'Género',
          VP_BIRTHDATE_IS_REQUIRED: 'Fecha de nacimiento',
          VP_BIRTHDATE_IS_INVALID: 'Fecha de nacimiento es inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil',
          VP_DNI_IS_REQUIRED: 'DNI',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que el número de documento del usuario, se encuentra duplicado en Visma People',
          VP_CUIL_IS_REQUIRED: 'CUIL',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de domicilio',
          VP_STREET_NAME_IS_REQUIRED: 'Calle',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Piso',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Departamento',
          VP_ZIPCODE_IS_REQUIRED: 'Código postal',
          VP_LOCALITY_IS_REQUIRED: 'Localidad/Ciudad',
          VP_PROVINCE_IS_REQUIRED: 'Provincia',
          VP_COUNTRY_IS_REQUIRED: 'País',
          VP_ORGANIZATION_MODEL_IS_REQUIRED: 'Modelo de organización',
          VP_HIREDATE_IS_REQUIRED: 'Fecha de ingreso/contratación'
        },
        massive_validations: {
          VP_FIRSTNAME_IS_REQUIRED: 'Nombre es requerido',
          VP_LASTNAME_IS_REQUIRED: 'Apellido es requerido',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidad es requerido',
          VP_GENRE_IS_REQUIRED: 'Género es requerido',
          VP_BIRTHDATE_IS_REQUIRED: 'Fecha de nacimiento es requerido',
          VP_BIRTHDATE_IS_INVALID: 'Fecha de nacimiento es inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil es requerido',
          VP_DNI_IS_REQUIRED: 'DNI es requerido',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que el número de documento del usuario, se encuentra duplicado en Visma People',
          VP_CUIL_IS_REQUIRED: 'CUIL es requerido',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de domicilio es requerido',
          VP_STREET_NAME_IS_REQUIRED: 'Calle es requerido',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número es requerido',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Piso es requerido',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Departamento es requerido',
          VP_ZIPCODE_IS_REQUIRED: 'Código postal es requerido',
          VP_LOCALITY_IS_REQUIRED: 'Localidad/Ciudad es requerido',
          VP_PROVINCE_IS_REQUIRED: 'Provincia es requerido',
          VP_COUNTRY_IS_REQUIRED: 'País es requerido',
          VP_ORGANIZATION_MODEL_IS_REQUIRED:
            'Modelo de organización es requerido',
          VP_HIREDATE_IS_REQUIRED: 'Fecha de ingreso/contratación es requerido',
          VISMA_PEOPLE_MEDIATOR:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          VISMA_PEOPLE_INVALID_POST_VALUES_MEDIATOR:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          EXTERNAL_API_COULD_NOT_CONNECT:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          VISMA_PEOPLE_ADDITIONAL_DATA:
            'Se creó el usuario en Visma People pero con errores en alguno de sus campos. Puede terminar de completar la información dentro de Visma People.'
        }
      }
    },
    main_document_page: {
      document: {
        title_document: 'Documentos',
        search_document: 'Pesquisa de documentos',
        subtitle_search_document:
          'Pesquise documentos nos arquivos de seus colaboradores',
        publish: 'Publicação em massa',
        subtitle_publish: 'Enviar documentos em massa para colaboradores'
      },
      publish: {
        title_publish: 'Publicação',
        individual: 'Publicação Individual',
        subtitle_individual: 'Envie um documento a um colaborador',
        generic: 'Publicação genérica',
        subtitle_generic:
          'Envie o mesmo documento em massa para mais de um colaborador',
        signature_reminder: 'Lembrete de assinatura',
        title_signature_reminder:
          'Enviar lembrete de assinatura em documentos pendentes'
      },
      forms: {
        title_publish: 'Formulários',
        publish_forms: 'Publicar Formulários',
        subtitle_publish_forms: 'Envie formulários para seus colaboradores',
        published_forms: 'Formulários publicados',
        subtitle_published_forms:
          'Consultas sobre os formulários enviados aos seus colaboradores',
        config_forms: 'Configuração do formulário',
        subtitle_config_forms: 'Criar ou modificar formulários'
      },
      management: {
        title_management: 'Gestão',
        publish_title_management: 'Gerenciamento de publicações',
        subtitle_publish_title_management:
          'Modificar status de publicações feitas',
        process_status: 'Status do processo',
        subtitle_process_status: 'Ver o estado das publicações realizadas'
      }
    },
    publishDocuments: {
      title: 'Publicación de documentos',
      goBack: 'Volver',
      configMassivePublish: {
        title: 'Publicación masiva de documentos',
        companyAlert: 'La publicación la vas a realizar en la empresa ',
        monthTitle: '¿A qué mes corresponde el documento?',
        monthContent:
          'Selecciona el mes que pertenece el documento que vas a disponibilizar a tus colaboradores. Disponible 1 mes hacia adelante y hasta 12 meses hacia atrás',
        monthSelect: 'Selecciona el mes',
        documentTypeTitle: '¿Que documento vas a enviarle a tu colaborador?',
        documentTypeContent:
          'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
        documentTypeSelect: 'Título de documento',
        documentProcessTitle:
          '¿Es necesario realizar algún proceso en los documentos?',
        documentProcessContent:
          'El documento final que va recibir tu colaborador requiere de algun proceso tales como division de pdf, rotación y firma de los documentos',
        documentProcessNone: 'Tengo los documentos listos para publicar',
        documentProcessNoneContent:
          'Los documentos ya están divididos y firmados externamente',
        documentProcessSplitSign: 'Necesito dividirlos y firmarlos',
        documentProcessSplitSignContent:
          'Vamos a realizar la división y firma de los documentos en la plataforma',
        documentProcessOnlySign: 'Necesito firmarlos',
        documentProcessOnlySignContent:
          ' Los documentos ya estan divididos externamente, vamos a realizar la firma en la plataforma',
        documentProcessSplit: 'Necesito dividirlos',
        documentProcessSplitContent:
          'Vamos a dividir los documentos, luego puedes bajar un archivo comprimido para firmarlo externamente',
        sendEmailTitle:
          '¿Quieres recibir los resultados de la publicación por email?',
        sendEmailContent:
          'Luego de realizar la publicación vas a recibir en el correo ingresado un resumen con los resultados de la publicación',
        email: 'Email',
        sendEmailCollabTitle: '¿Quieres notificar a los colaboradores ?',
        sendEmailCollabContent:
          'Tus colaboradores van a recibir un email notificándoles de que tienen una nueva publicación para revisar',
        sendEmailCollabYes: 'Si, notificar colaboradores',
        sendEmailCollabNo: 'No',
        sendPushCollab: 'Incluir notificación push',
        btnNext: 'Siguiente',
        btnCancel: 'Cancelar',
        badgeNews: 'Próximamente',
        publish: 'Publicar',
        signAndPublish: 'Firmar y publicar',
        hasCertEnabled:
          'No tienes un certificado para firmar los documentos electrónicamente',
        noPermissionCert:
          'No tienes un certificado vigente para firmar los documentos electrónicamente.',
        emailCertEmptyRecipients:
          'No hay un usuario definido con certificado activo para firmar los documentos electrónicamente, por favor contacte con soporte.',
        noEmail:
          'El usuario con permisos para crear certificados no tiene un email asociado en el sistema.',
        hasFnParser:
          'Este documento tiene un proceso de captura que no admite el proceso de corte y firma',
        noSignPosition:
          'No tienes definido el posicionamiento de la firma del empleador',
        createCert: 'Crear certificado',
        contactAdmin: 'Contactar administrador',
        configSignPosition: 'Configurar firma empleador'
      },
      onlyPublish: {
        title: 'Carga de archivo',
        subtitle: 'Seleccione un archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el archivo .zip listo para ser publicado (ya cortado y firmado de manera externa).',
        label: 'Selecciona tu archivo',
        uploadingFile: 'Subiendo archivo',
        fileSizeExceded: 'El archivo no puede superar los 750 MB',
        wrongFiletype: 'El archivo debe tener extensión .zip',
        success: '<strong>{quantity}</strong> Documentos procesados',
        modal: {
          title: 'Publicación de documentos',
          title_container:
            '¿Estas seguro de que quieres publicar los documentos?',
          description:
            'Los documentos van a ser disponibilizados a tus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Si, publicar'
        },
        modalCancel: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        }
      },
      onlySign: {
        title: 'Carga de archivo',
        subtitle: 'Seleccione un archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el archivo .zip con los documentos dividos externamente, aplicaremos la firma para que lo puedas publicar',
        label: 'Selecciona tu archivo',
        uploadingFile: 'Subiendo archivo',
        fileSizeExceded: 'El archivo no puede superar los 750 MB',
        wrongFiletype: 'El archivo debe tener extensión .zip',
        success: '<strong>{quantity}</strong> Documentos procesados',
        modal: {
          title: 'Publicación de documentos',
          title_container:
            '¿Estas seguro de que quieres publicar los documentos?',
          description:
            'Los documentos van a ser disponibilizados a tus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Si, publicar'
        },

        modalCancel: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      split_and_crop: {
        title: 'Carga de archivo',
        subtitle: 'Seleccione el archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el pdf sabana original</br>Lo dividiremos para que lo puedas firmar externamente y lo puedas publicar',
        label: 'Selecciona tu archivo pdf',
        uploadingFile: 'Subiendo archivo',
        wrongFiletype: 'El archivo debe tener extensión .pdf',
        proccessWait:
          'Este proceso puede demorar unos minutos<br>Puedes consultarlo en <strong><u><a href="{link}">Estado de procesos</a></u></strong>',
        documentsProcessed: 'Total de archivos divididos',
        howToSignDocuments: '¿Cómo firmo los documentos de manera digital?',
        howToSignDocuments_1_1: 'Descarga el Archivo ',
        howToSignDocuments_1_2:
          'Firma los documentos externamente de manera digital',
        howToSignDocuments_1_3: 'Carga el archivo .zip con los pdf firmados',
        preview: 'Previsualizar archivo',
        download_file: 'Descargar archivo',
        download_file_loader: 'Descargando',
        next: 'Siguiente',
        modalCancel: {
          title: 'Publicación de documentos',
          title_container: '¿Estás seguro que deseas cancelar la publicación?',
          description: 'Se perderán los documentos procesados',
          cancel: 'Cancelar',
          confirm: 'Aceptar'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      split_crop_and_sign: {
        title: 'Carga de archivo y firma de documento',
        subtitle: 'Seleccione el archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el pdf sabana original</br>Lo dividiremos y firmaremos en la plataforma',
        label: 'Selecciona tu archivo pdf',
        wrongFiletype: 'El archivo debe tener extensión .pdf',
        uploadingFile: 'Subiendo archivo',
        proccessWait:
          'Este proceso puede demorar unos minutos<br>Puedes consultarlo en <strong><u><a href="{link}">Estado de procesos</a></u></strong>',
        pdfSplited: 'PDFs Cortados',
        preview: 'Previsualizar archivo',
        goToList: 'Volver al listado',
        documentsProcessed: '<strong>{input}</strong> Documentos procesados',
        next: 'Firmar y publicar',
        modal: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        },
        modalSignAndPublish: {
          title: 'Firma electrónica',
          titleSelect: 'Seleccionar certificado de firma',
          description:
            'Para poder firmar esta publicación tienes que ingresar la contraseña del <strong>certificado electrónico</strong>',
          descriptionSelect:
            'Selecciona el certificado para firmar los documentos',
          buttonSelect: 'Seleccionar',
          advise:
            'Al confirmar tus documentos van a ser disponibilizados a tus colaboradores',
          selected: 'Certificado de firma seleccionado',
          changeCertificate: 'Cambiar de certificado',
          labelInput: 'Ingrese la contraseña',
          cancel: 'Cancelar',
          confirm: 'Confirmar',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'No tienes un certificado activo para realizar la publicación',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID: 'Contraseña incorrecta',
          SIGN_DOCUMENT_TAG_NOT_FOUND: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_NOT_CREATED: 'Ocurrió un error, consulta con soporte'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      configIndivualPublish: {
        title: 'Publicación individual',
        subtitle: 'Configuración inicial',
        inputCuil: {
          label: 'Identificador',
          question: '¿Cuál es el Identificador del colaborador?',
          description:
            'Ingresa el Identificador del colaborador al que quieres enviarle un documento'
        },
        inputPeriod: {
          label: 'Selecciona el periodo al que pertenece el documento',
          question: '¿A que mes corresponde el documento?',
          description:
            'Selecciona el mes que pertenece el documento que vas a disponibilizar a tus colaborador. ' +
            'Disponible 1 mes hacia adelante y hasta 12 meses hacia atrás'
        },
        inputDocumentType: {
          label: 'Selecciona un tipo de documento',
          question: '¿Qué documento vas a enviarle a tu colaborador?',
          description:
            'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
          noDocuments: 'No se encotró el documento'
        },
        checkDocumentSign: {
          label: 'Incluir firma de la empresa',
          question: '¿Quieres firmar los documentos?',
          description:
            'El documento pasará primero por el proceso de firma en la que se le incorporará la firma de la empresa'
        },
        checkNotificationMail: {
          label: 'Enviar email',
          question: '¿Quieres notificar al colaborador?',
          description:
            'Tus colaborador recibirá un email notificándole de que tiene una nueva publicación para revisar'
        },
        publishLoadDocument: {
          label: 'Selecciona tu archivo',
          question: 'Selecciona el archivo a enviar',
          description: 'Puedes utilizar los siguientes tipos de archivos',
          filePreview: 'Previsualizar archivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento',
          publishAndSign: 'Firmar y publicar'
        },
        modal: {
          success: 'Publicación realizada con éxito',
          publicNew: '¿Quieres enviar otro documento a un colaborador?',
          description:
            'Puedes continuar realizando envíos de documentos a tus colaboradores',
          leave: 'Salir',
          publicOther: 'Publicar otro documento'
        },
        errors: {
          SYSTEM_API_INVALID_CUIL: 'O cuil é inválido',
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'Não foi possível criar o diretório',
          SYSTEM_API_FILE_EXISTS: 'O arquivo já existe',
          SYSTEM_API_NOT_CREATE_REGISTRY_CARGA:
            'Não foi possível criar registro de upload',
          SYSTEM_API_DOCUMENT_NOT_PUBLISHED:
            'O documento não pôde ser publicado',
          SYSTEM_API_NOT_SEND_NOTIFICATION:
            'Não foi possível enviar notificação',
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Um ou mais parâmetros são inválidos',
          SYSTEM_API_NOT_MOVE_FILE:
            'O arquivo não pôde ser movido para a pasta',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Um ou vários parâmetros são necessários',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'O tamanho da folha pdf não é permitido para publicação',
          SIGN_DOCUMENT_CANNOT_CREATE_DIRECTORY:
            'Não é possível criar diretório de processo',
          SIGN_DOCUMENT_CANNOT_UNZIP_FILE:
            'Não é possível descompactar o arquivo enviado',
          SIGN_DOCUMENT_CERT_HAS_EXPIRED: 'O certificado expirou',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID:
            'A senha do certificado é inválida',
          SIGN_DOCUMENT_INVALID_OUTPUT_JSON:
            'Não é possível obter o caminho da pasta',
          SIGN_DOCUMENT_INVALID_OUTPUT: 'A saída agendada é inválida',
          SIGN_DOCUMENT_INVALID_TAG_OUTPUT_STATUS:
            'O status de saída da tarefa atribuída é inválido',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'Você não possui um certificado ativo para publicar',
          SIGN_DOCUMENT_TAG_NOT_FOUND:
            'Ocorreu um erro, verifique com o suporte',
          SIGN_DOCUMENT_INVALID_TAG:
            'Ocorreu um erro, entre em contato com o suporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Ocorreu um erro, verifique com o suporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Ocorreu um erro, entre em contato com o suporte',
          SIGN_DOCUMENT_NOT_CREATED:
            'Ocorreu um erro, entre em contato com o suporte',
          '268': 'Este PDF está encriptado e não pode ser processado'
        }
      },
      configGenericPublish: {
        title: 'Publicación Genérica',
        subtitle: 'Configuración inicial',
        inputDocumentType: {
          label: 'Selecciona un tipo de documento',
          question: '¿Qué documento vas a enviarle a tu colaborador?',
          description:
            'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
          noDocuments: 'No se encotró el documento'
        },
        inputSector: {
          title: 'Sector',
          label: 'Selecciona un sector',
          question: 'Selecciona sector y locación',
          description:
            'Selecciona el sector y la locación de quienes van a recibir este documento',
          clear: 'Limpiar selección',
          noResult: 'No hay sectores',
          required: 'Este campo es requerido'
        },
        inputLocation: {
          title: 'Locación',
          label: 'Selecciona una locación',
          clear: 'Limpiar selección',
          noResult: 'No hay locaciones',
          required: 'Este campo es requerido'
        },
        checkNotificationMail: {
          label: 'Enviar email',
          question: '¿Quieres notificar al colaborador?',
          description:
            'Tus colaborador recibirá un email notificándole de que tiene una nueva publicación para revisar'
        },
        publishLoadDocument: {
          label: 'Selecciona tu archivo',
          question: 'Selecciona el archivo a enviar',
          description: 'Puedes utilizar los siguientes tipos de archivos',
          filePreview: 'Previsualizar archivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento'
        },
        modal: {
          success: 'Publicación realizada con éxito',
          publicNew: '¿Quieres enviar otro documento a los colaboradores?',
          description:
            'Puedes continuar realizando envíos de documentos a tus colaboradores',
          leave: 'Salir',
          publicOther: 'Publicar otro documento'
        },
        errors: {
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'No se pudo crear el directorio',
          SYSTEM_API_FILE_EXISTS: 'El archivo ya existe',
          SYSTEM_API_NOT_CREATE_REGISTRY_CARGA:
            'No se pudo crear el registro de carga',
          SYSTEM_API_DOCUMENT_NOT_PUBLISHED:
            'El documento no pudo ser publicado',
          SYSTEM_API_NOT_SEND_NOTIFICATION: 'No se pudo enviar la notificación',
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Uno o varios parámetros son inválidos',
          SYSTEM_API_NOT_MOVE_FILE:
            'El archivo no pudo ser movido a la carpeta',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Uno o varios parámetros son requeridos',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'El tamaño de hoja del pdf no esta permitido para la publicación'
        }
      },
      errors: {
        SYSTEM_API_WRONG_MIME_TYPE: 'O arquivo tem um formato inválido',
        SYSTEM_API_ZIP_SUSPICIOUS_FORMAT: 'O arquivo ZIP tem um formato suspeito ou inseguro',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP_PDF_FILES:
          'Archivo inválido. No se puede descomprimir',
        PUBLISH_DOCUMENT_MASSIVE_ZIP_WAITING_PROCESSED:
          'Ya existe un ZIP esperando a ser procesado',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_DOCUMENTS_COUNTS:
          'Archivo inválido, por cada PDF debe haber un XML',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP:
          'Archivo ZIP inválido, no se puede descomprimir',
        SYSTEM_API_INVALID_SUBFOLDERID: 'ID de subcarpeta inválido',
        PDF_FILE_PAGE_SIZE_EXCEPTION:
          'El tamaño de página del PDF no está permitido',
        SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
          'El archivo no puede superar los 750 MB',
        SIGN_DOCUMENT_CERT_NO_EXISTS:
          "En este momento no hay un certificado activo para la firma y publicación.<br><span class='text-base mt-4'>Por favor, para continuar, genera un nuevo certificado en la sección de Certificados de firma electrónica.</span>",
        ERROR_CANCEL_PROCESS:
          'Ocurrió un error eliminando el documento<br>Por favor contactate con soporte',
        PAGE_REQUESTED_NOT_FOUND:
          'La pagina que se quiere visualizar no se encuentra en el archivo',
        ERROR_PREVIEW_GENERAL:
          'Ocurrió un error inesperado<br>Por favor contactate con soporte',
        EMAIL_VALUE_IS_INVALID:
          'O e-mail informado não é válido',
      }
    },
    certificates: {
      title: 'Certificados de firma electrónica',
      createCert: 'Crear certificado',
      createAlertTitle:
        'Alcanzaste la cantidad máxima de certificados activos en la empresa.',
      createCertAlertSteps: 'Para crear uno nuevo puedes:',
      createCertAlertSteps_1: 'Expirar un certificado existente',
      createCertAlertSteps_2: 'Esperar al vencimiento de un certificado activo',
      newCertificate: {
        title: 'Datos requeridos para la creación del certificado',
        subtitle:
          'Completa los siguientes campos para generar el certificado para firmar electrónicamente.<br>El certificado es uno solo por empresa.',
        required: '* Todos los campos son obligarios',
        personalInfo: {
          title: 'Datos personales',
          subtitle:
            'Complete los campos correspondientes con sus datos personales',
          nameAndSurname: 'Nombre y Apellido',
          position: 'Cargo en la empresa',
          email: 'Email',
          dni: 'Documento'
        },
        companyInfo: {
          title: 'Datos de la empresa',
          subtitle:
            'Complete los campos correspondientes con los datos de la empresa',
          name: 'Razón social',
          uniqueId: 'Identificador único de la empresa'
        },
        password: {
          title: 'Contraseña',
          subtitle: 'Reemplazar por política de contraseña por empresa',
          password: 'Ingrese contraseña',
          repeatPassword: 'Confirmar contraseña'
        },
        signView: 'Visualización de firma en documentos',
        signInfo:
          'El colaborador va a visualizar la firma electrónica de la siguiente forma',
        signElectronic: 'FIRMADO ELECTRONICAMENTE',
        signName: 'NOMBRE Y APELLIDO',
        signCharge: 'CARGO',
        dni: 'Documento',
        responsabilityTitle: 'Responsabilidad del uso de certificados',
        responsabilityLegend:
          'Entiendo que estoy habilitado para la creación de certificados por parte de la organización, y el resguardo de la contraseña generada queda bajo mi responsabilidad.',
        responsabilityCheckbox: 'Si, entendido',
        cancel: 'Cancelar',
        cancelQuestion: '¿Desea cancelar la creación del certificado?',
        cancelDataLost: 'Se perderán los datos ingresados.',
        accept: 'Aceptar',
        create: 'Crear certificado',
        successTitle: 'Certificado creado',
        successText: 'Certificado creado exitosamente',
        errors: {
          title: 'Ocurrió un error',
          '00026':
            'El password ya ha sido previamente usado, por favor coloca otro password e intenta de nuevo',
          '00141':
            'El password no cumple con la políticas de contraseña de la empresa, por favor verifica el password e intenta de nuevo',
          generic:
            'Ocurrió un error creando el certificado. Por favor contactate con soporte'
        },
        gotIt: 'Entendido'
      },
      emptyState: {
        title: 'Esto es un desierto...',
        noCert: 'No tienes un certificado activo para firmar los documentos',
        noCert2: 'No hay documentos nuevos en tu bandeja de tareas',
        createCert:
          'Para crear uno nuevo presiona el botón <strong>Crear certificado</strong>'
      },
      certificatesList: {
        activeTitle: 'Certificado activo',
        expiredTitle: 'Certificados expirados',
        createdBy: 'Creado por <strong>{input}</strong>',
        creationDate: 'Fecha creación <strong>{input}</strong>',
        validDate: 'Válido hasta {input}',
        expiredDate: 'Expirado {input}',
        btnCertificate: 'Ver certificado',
        btnExpireCertificate: 'Expirar',
        certificateModal: {
          closeBtn: 'Cerrar',
          modalTitle: 'Vista del certificado',
          certExpired: 'Certificado expirado',
          certActive: 'Certificado activo',
          validDate: 'Válido hasta {input}',
          expiredDate: 'Expirado {input}',
          personalDataTitle: 'Datos personales',
          fullName: 'Nombre y Apellido',
          position: 'Cargo en la empresa',
          email: 'Email',
          companyDataTitle: 'Datos de la empresa',
          companyName: 'Razón social',
          companyCuit: 'Cuit'
        }
      },
      expireCertificate: {
        expireModalTitle: 'Expirar certificado',
        expireModalBodyTitle: '¿Estás seguro de expirar este certificado?',
        expireModalSubtitle:
          'El certificado quedará inactivo y no se podrá volver a utilizar.',
        errors: {
          COMPANY_CERT_ALREADY_EXPIRED: 'El certificado ya expiró',
          COMPANY_CERT_NOT_FOUND: 'No se encuentra el certificado'
        }
      }
    },
    employees: {
      administration: {
        error: {
          SYSTEM_API_INVALID_PROFILE_TYPE_ID:
            'O ID não é um tipo de perfil inválido',
          SYSTEM_API_INVALID_CUIL: 'Cuil inválido',
          SYSTEM_API_PARAMETER_REQUIRED:
            'profileTypesId é um parâmetro obrigatório',
          SYSTEM_API_WRONG_MIME_TYPE:
            'Formato de arquivo incorreto. O arquivo enviado deve estar no formato .csv'
        },
        message: {
          error: 'O arquivo não foi processado pelos seguintes motivos',
          info: 'O processo foi concluído, mas com erros',
          success: '¡Processo concluído!',
          inserted: {
            label: 'Usuários atualizados {quantity} de {total} usuários.'
          },
          failed: {
            observation: 'Usuário não existe',
            label: 'Falharam {quantity} usuários de {total} usuários.',
            link: 'Clique para baixar a lista de falhas.'
          },
          inactive: {
            observation: 'O usuário está definido como inativo',
            label: 'Usuários inativos {quantity} de {total} usuários.'
          },
          duplicates: {
            observation:
              'Um registro anterior com este identificador já foi atualizado',
            label:
              'Foram detectados {quantity} registros duplicados de {total} usuários informados.',
            link: 'Clique aqui para baixar a lista de duplicatas no arquivo.'
          }
        },
        profileIntegration: {
          title: 'Gerenciar perfis de integração',
          subTitle: 'Gerenciamento de perfil',
          name: 'Perfis de integração',
          step: {
            question: '1. Faça uma lista de contas de usuário',
            description:
              'Crie um arquivo CSV para construir a lista de usuários.',
            link: 'Você pode baixar este exemplo para preencher'
          },
          step1: {
            question: '2. Perfis de integração',
            assign: 'Atribuir',
            unassign: 'Adiar',
            noResult: 'Sem perfis',
            add: 'Adicionar'
          },
          step2: {
            question: '3. Carregar arquivo',
            selectFile: 'Selecione um arquivo'
          },
          help: '¿Precisa de ajuda?',
          toSaveAssign: 'Atribuir perfil',
          toSaveUnassign: 'Remover perfil',
          validFile: 'O arquivo deve ter uma extensão .csv'
        }
      }
    },
    updateLogo: {
      saveButton: 'Salvar',
      cancelButton: 'Cancelar',
      modalConfirm: 'Confirme',
      title: 'Atualmente Usado',
      subtitle: 'Imagem enviada',
      header: 'Atualização da Marca',
      uploadingFile: 'Carregando arquivo',
      newLogoPlaceholder: 'Novo logotipo',
      modalHeader: 'Confirmar atualização',
      actualLogoPlaceholder: 'Logotipo atual',
      inputPlaceholder: 'Selecione um arquivo',
      modalTitle:
        '¿Tem certeza de que deseja aplicar esta modificação de marca?',
      modalText:
        'Esta modificação afetará a marca da empresa que todos os seus colaboradores visualizam.',
      errors: {
        unauthorized: 'Acesso negado',
        wrongType: 'O tipo de arquivo não é permitido',
        parameterExpected: 'O parâmetro "logo" é esperado',
        exception: 'O logotipo da empresa não pode ser salvo',
        maxSizeExceeded: 'O tamanho do arquivo excede o limite permitido'
      }
    },
    updateColors: {
      previewClose: 'Perto',
      previewHeader: 'Paleta de cores de visualização',
      header: 'Paleta de cores',
      title: 'Personalize as cores da plataforma',
      description:
        'As alterações que você fizer na paleta de cores serão refletidas na barra lateral, botões e em alguns detalhes da plataforma, ficará visível para todos os seus colaboradores',
      subtitle: 'Cores básicas',
      inputColor1: 'Cor primária (barra lateral, botões)',
      inputColor2: 'Cor secundária (quando o usuário coloca o cursor no ícone)',
      inputColor3: 'Cor terciária (quando a opção é selecionada)',
      subtitle2: 'Cores do título',
      inputTitle: 'Cor primária (títulos)',
      subtitle3: 'Texto e iconografia do menu e botões',
      iconTextDescription:
        'Isto afecta o texto do menu lateral e o texto dosícones',
      cancelButton: 'Cancelar',
      white: 'Branca',
      black: 'Negro',
      restoreDefault: 'Redefinir as cores da plataforma',
      restoreDefaultDescription: 'Redefinir cores padrão',
      saveButton: 'Salvar',
      modalHeader: 'Confirmar atualização',
      modalTitle:
        'Tem certeza de que deseja aplicar essa modificação à paleta de cores?',
      modalText:
        'Essa modificação afetará as cores que seus colaboradores veem na plataforma',
      modalConfirm: 'Confirmar',
      modalReturn: {
        title: 'Personalização de cores',
        cancel: 'Não, prosseguir ',
        cancelQuestion: 'Deseja cancelar a personalização de cores?',
        cancelDataLost: 'Os dados inseridos serão perdidos.',
        accept: 'Sim, cancele'
      }
    },
    main_bussines_page: {
      business: {
        title_bussines: 'O negócio',
        folder_settings: 'Configurações de pasta',
        subtitle_folder_settings:
          'Defina as pastas e o local onde os diferentes documentos serão armazenados',
        news_billboard: 'outdoor de notícias',
        subtitle_news_billboard:
          'Poste notícias na tela inicial do seu colaborador'
      },
      workflow: {
        title_workflow: 'O fluxo de trabalho',
        workflow_creation: 'Criação de fluxo',
        subtitle_workflow_creation:
          'Estabelece por quem os documentos serão passados para serem aprovados',
        group_management: 'Gerenciamento de grupo',
        subtitle_group_management:
          'Defina como serão compostos os grupos de aprovadores',
        configuration: {
          create: 'Crear flujo de trabajo',
          title: 'Configuración',
          flow_name: {
            title: '¿Cuál es el nombre de este flujo de trabajo?',
            description:
              'El nombre te va a servir para identificar quienes son los involucrados en el orden de aprobación y los documentos, trata de que sea un nombre descriptivo',
            input_placeholder: 'Nombre del flujo de trabajo'
          },
          selection_approves: {
            title: 'Selección de aprobadores',
            description:
              'Por favor, selecciona los aprobadores del circuito de aprobación,\n' +
              'recuerda el orden seleccionado, será el mismo en el que van a ser aprobados',
            subsection_title: 'Orden de aprobación',
            select_placeholder: 'Busca o selecciona del listado',
            add_other_approves: 'Agregar otro'
          },
          selection_document: {
            title: 'Selección de documentos',
            description:
              'Por favor, selecciona los documentos que deberán pasar por el circuito de aprobación, dichos documentos no podrán ser utilizados en otro circuito',
            subsection_title: 'Documento',
            select_placeholder: 'Selecciona el tipo de documento',
            add_other_document: 'Agregar otro'
          },
          button_save: 'Guardar',
          button_cancel: 'Cancelar',
          button_cancel_alt: 'Si, salir',
          buttonBack: 'Volver'
        },
        modals: {
          create: {
            title: 'Guardar flujo de trabajo',
            body: '¿Estás seguro que quieres guardar el Flujo de trabajo',
            var_body: '{name}?',
            body_success:
              'El flujo de trabajo con nombre {name} fue creado correctamente',
            body_error: 'Ocurrió un error al crear el flujo de trabajo',
            button_success: 'Cerrar'
          },
          destroy: {
            title: 'Salir de flujos de trabajo',
            body_title: '¿Estás seguro que quieres salir?',
            body: 'Puedes continuar con este flujo de trabajo en cualquier momento desde Gestión de flujos (se guardará como borrador )'
          },
          errors: {
            DOCUMENT_EXISTS_IN_WORKFLOW:
              'El documento existe en otro flujo de trabajo',
            INCORRECT_APPROVING_GROUP: 'El grupo aprobador es incorrecto',
            SYSTEM_API_WRONG_DATA_TYPE:
              'Los valores del tipo de dato son incorrectos'
          },
          disabled: {
            title: 'Desactivar flujo',
            body_title: '¿Estás seguro que quieres desactivar este flujo?',
            body: 'Este flujo se desactivará y no podrás utilizarlo',
            cancel: 'Cancelar',
            action: 'Desactivar'
          },
          groups: {
            title: 'Miembros del grupo',
            action: 'Cerrar'
          }
        },
        table: {
          title: 'Flujos creados',
          headers: {
            date: 'Fecha',
            actions: 'Acciones',
            modifiedby: 'Modificado por',
            status: 'Estado',
            groups: 'Grupos',
            nameWorkflow: 'Nombre del workflow'
          },
          badge: {
            cancelled: 'Cancelado',
            active: 'Activo'
          },
          tooltipGroup: 'Ver miembros del grupo',
          tooltipCancel: 'Desactivar flujo'
        }
      },
      notifications: {
        title_notifications: 'Configurações de notificação',
        welcome_email: 'e-mail de boas-vindas',
        subtitle_welcome_email:
          'Envie um e-mail para seus colaboradores com as boas-vindas à plataforma',
        Personalize_emails: 'Personalizar e-mails',
        subtitle_Personalize_emails:
          'Modifique as comunicações que seu colaborador receberá'
      },
      personalization: {
        title_personalization: 'Personalização',
        brand_update: 'atualização da marca',
        subtitle_brand_update:
          'Você pode substituir a imagem corporativa na plataforma',
        color_palette: 'Paleta de cores',
        subtitle_color_palette:
          'Selecione ou personalize as cores da plataforma'
      },
      other_settings: {
        title_other_settings: 'Segurança',
        mfa: 'Autenticação dupla MFA',
        subtitle_mfa:
          'Eestabeleça se seus colaboradores possuem duplo fator de autenticação',
        audit: 'Auditoría',
        subtitle_audit:
          'Realizar auditorias das ações realizadas na plataforma',
        security_Center: 'Centro de Segurança',
        subtitle_security_center:
          'Gerencie as permissões de seus colaboradores na plataforma'
      },
      onboarding: {
        title_onboarding: 'Onboarding',
        onboarding_settings: 'Configuração de integração',
        subtitle_onboarding_settings:
          'Estabeleça os dados que você vai pedir ao seu colaborador no onboarding'
      },
      certificate: {
        title_certificate: 'Certificados',
        electronic_sign_cert: 'Certificados de assinatura eletrônica',
        subtitle_electronic_sign_cert: 'Certificados de firma electrónica'
      },
      self_service: {
        title_self_service:
          'Gerenciamento de autoatendimento para dados de funcionários',
        data_update: 'Atualização de dados',
        subtitle_data_update:
          'Habilite a opção para seu colaborador atualizar seus dados',
        bank_data: 'Dados bancários',
        subtitle_bank_data:
          'Realizar auditorias das ações realizadas na plataforma'
      }
    },
    cancelDocuments: {
      info: 'Não foi possível cancelar os documentos, tente novamente mais tarde',
      error: {
        GENERIC: 'Os documentos selecionados foram cancelados com sucesso',
        MASSIVE_CANCEL_NONEXISTENT: 'Os ids não existem',
        MASSIVE_CANCEL_DUPLICATE: 'Existem IDs duplicados',
        SYSTEM_API_PARAMETER_REQUIRED: 'Ids é um parâmetro obrigatório',
        SYSTEM_API_WRONG_DATA_TYPE: 'Valor de tipo de dados incorreto - ids',
        SYSTEM_API_MAX_ARRAY_COUNT_EXCEEDED:
          'O número máximo de IDs foi excedido.'
      },
      heading: 'Cancelar documentos',
      title: 'Tem certeza de que deseja cancelar os documentos selecionados?',
      content:
        'Apenas os documentos selecionados na página atual serão excluídos',
      footer: {
        cancel: 'Cancelar',
        cancelled: 'sim, cancela'
      }
    },
    selfService: {
      taskManager: {
        contact: 'Datos de contacto',
        bank: 'Datos bancarios',
        identifies: 'Cómo me identifico',
        address: 'Cambio de domicilio',
        field: {
          cbuAlias: 'Número de cuenta',
          contactPerson: 'Persona de contacto de emergencia',
          contactType: 'Tipo de contacto',
          emergencyPhone: 'Teléfono de emergencia',
          personalPhone: 'Teléfono celular',
          personalPhoneHouse: 'Teléfono fijo',
          bank: 'Selecciona tu banco',
          bankAccountType: 'Tipo de cuenta',
          myNickName: 'Nickname',
          nameBank: 'Banco',
          cbu: 'Número de cuenta',
          copy: 'Copiar CBU',
          download: 'Descargar',
          myName: '¿Cómo quieres que te llamemos?',
          myLastName: 'Cuál es tu apellido',
          myGenre: 'Género',
          country: 'País de residencia',
          state: 'Provincia / Estado',
          city: 'Ciudad',
          street: 'Calle',
          addressNumber: 'Número',
          floor: 'Piso',
          department: 'Departamento',
          neighborHood: 'Barrio',
          blockStreet: 'Manzana',
          addressType: 'Tipo de domicilio',
          myAvatar: 'Foto actualizada'
        },
        fieldsError: {
          nickName: {
            required: 'El Nombre es requerido',
            regex: 'Solo se admiten letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          nameBank: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          cbu: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          typeAccount: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          }
        },
        fieldRequired: 'Este campo é obrigatório'
      },
      statusOk: 'La información del usuario se modificó con éxito',
      errors: {
        ACTION_ALREADY_EXISTS: 'Essas ações já existem',
        FAILED_SAVE_DATA:
          'Não foi possível salvar a configuração, tente novamente, se o erro persistir contate o suporte',
        SYSTEM_API_PARAMETER_REQUIRED: 'Um ou mais parâmetros são necessários',
        SYSTEM_API_WRONG_DATA_TYPE:
          'Há campos que contêm um valor de tipo incorreto',
        EXPECTED_PARAMETER_VALUE: 'Um ou vários campos são necessários',
        FAILED_DELETE_ACTION: 'Ocorreu um erro ao tentar remover a permissão'
      },
      title: 'Atualização de dados',
      subTitle: 'Configuração',
      linkBack: 'Retornar',
      linkCancel: 'Cancelar',
      linkSave: 'Salvar',
      linkSaveChanged: 'Guardar Alterações',
      linkSaveInformation: 'Guardar Informação',
      linkDownloadPicture: 'Baixar foto',
      success: 'A configuração foi salva com sucesso',
      isOk: 'É entendido',
      linkLeave: 'Sim, saia',
      leaveQuest: 'Tem certeza de que deseja sair da configuração?',
      radioOk: 'Sim permitir',
      radioNot: 'Não permitir',
      addressQuest:
        'Deseja permitir que seu colaborador atualize seu endereço?',
      addressDescription:
        'Permita que seu colaborador atualize seu local de residência, selecionando país, cidade e endereço',
      bankQuest:
        'Deseja permitir que seu colaborador atualize seus dados bancários?',
      bankDescription:
        'Permita que seu colaborador atualize o banco no qual receberá sua remuneração, ele poderá selecionar o banco e inserir o cbu/alias',
      contactQuest:
        'Deseja permitir que seu colaborador atualize suas informações de contato?',
      contactDescription:
        'Permita que seu colaborador atualize seu contato e número de telefone de emergência',
      identifiesQuest:
        'Deseja permitir que seu colaborador atualize sua identificação (gênero)?',
      identifiesDescription:
        'Permita que seu colaborador atualize como se percebe, ele pode inserir seu nome, sobrenome, sexo e uma foto (opcional)',
      infoEmployee: {
        tab: {
          personalData: 'Dados pessoais',
          contactData: 'Dados de contato',
          bankData: 'Dados bancários',
          identificationData: 'Como eu me identifico',
          addressData: 'Detalhes do endereço'
        }
      },
      whereToStoreDocument: 'Onde você deseja armazenar o documento?',
      selectFolderForUpdateDocument:
        'Selecione uma pasta onde será salvo o documento de atualização de endereço do colaborador (declaração juramentada)'
    },
    company: {
      welcomeEmail: {
        title: 'e-mail de boas-vindas',
        subTitle: 'Este é o e-mail que seus colaboradores receberão',
        description:
          'Aqui você pode visualizar o conteúdo do e-mail que seus colaboradores receberão em sua caixa postal cadastrada na plataforma',
        actionCancel: 'Cancelar',
        actionSend: 'Eu envio e-mails de boas-vindas',
        actionOk: 'Aceitar',
        actionBack: 'Retornar',
        messageSended:
          'E-mails foram enviados para todos os usuários que ainda não fizeram sua primeira entrada.',
        modal: {
          title: 'Eu envio e-mails de boas-vindas',
          body: 'Você está prestes a enviar o e-mail de boas-vindas para toda a sua folha de pagamento ativa, este processo é um processo único. Deseja continuar?'
        },
        errors: {
          WELCOME_EMAIL_ALREADY_USED: 'A empresa já ativou o envio de mails.',
          NOT_RESULT: 'Não há novos usuários para enviar o mail.',
          INVALID_TOKEN: 'Token de autenticação inválido',
          DEFAULT_ERROR: 'Ocorreu um erro ao tentar ativar o envio de emails.'
        }
      }
    },
    customEmails: {
      title: 'Personalizar e-mails',
      go_back_btn: 'Retornar',
      template: {
        edit_btn: 'Editar',
        empty_email_template:
          'Em breve você poderá personalizar os e-mails correspondentes a esta seção.'
      },
      descriptionHeader: 'Este é o e-mail que seus colaboradores receberão',
      description:
        'Aqui você pode visualizar o conteúdo do e-mail que seus colaboradores receberão em suas caixas de correio cadastradas na plataforma',
      restoreDefault: 'Restaurar seções padrão',
      cancel: 'Cancelar',
      save: 'Salve',
      edit: 'Editar',
      imgEdit: 'Editor de imagens',
      imgDescription: 'Alguns dados que você pode usar dinamicamente',
      restore: 'Restaurar',
      accept: 'Aceita',
      emptyLibrary: 'Ainda não há imagens na biblioteca',
      load: 'Carregar',
      library: 'Galeria',
      errors: {
        COMPANY_GALLERY_LIMIT_EXCEPTION: 'O limite de 20 imagens foi excedido',
        IMAGE_LIMIT_SIZE: 'O arquivo não pode exceder 1 MB',
        IMAGE_TYPE: 'O arquivo deve ter a extensão .jpg, .png'
      },
      succesMessage: 'upload bem-sucedido',
      select_file: 'Selecione um arquivo',
      cancelModal: {
        message:
          'Tem certeza de que deseja cancelar a personalização deste e-mail?',
        caption: 'Os dados inseridos serão perdidos.',
        confirmBtn: 'sim, cancele',
        cancelBtn: 'Não, continue'
      },
      confirmModal: {
        message:
          'Tem certeza de que deseja aplicar as modificações a este modelo de e-mail?',
        confirmBtn: 'Guarda',
        cancelBtn: 'Cancelar'
      },
      alertInformation:
        'Você só pode enviar no máximo 20 imagens. Eles não podem ser excluídos.'
    },
    reports: {
      title: 'Relatórios',
      graphs: {
        graphReceived: {
          title: 'Total de receitas - Últimos 12 meses',
          label: 'Receitas'
        },
        graphCompliant: {
          title:
            'Recibos em conformidade vs. recibos não conformes - Últimos 12 meses',
          labels: ['Em conformidade', 'Não conforme'],
          label: 'Período de'
        },
        graphSigned: {
          title: 'Recibos assinados vs. não assinados - Intervalo de prazos',
          labels: ['Assinado', 'Não Assinado'],
          fromPeriod: 'De',
          toPeriod: 'Até'
        }
      }
    },
    processManager: {
      title: 'Gerenciador de processos',
      tableTitle: 'Consulta de status de processos',
      update: 'Atualizar',
      filters: {
        searchUser: 'Buscar usuário',
        noResults: 'Nenhum resultado encontrado',
        selectDate: 'Selecione uma data',
        search: 'Buscar'
      },
      table: {
        empty: 'Sem resultados',
        inProgress: 'Em progresso',
        withObservation: 'Concluído, mas com observações',
        withError: 'Erro',
        withSuccess: 'Sucesso',
        processed: 'Documentos processados',
        canceled: 'Cancelado',
        continue: 'Continuar'
      },
      errors: {
        CUT_PARAMETERS_NOT_DEFINED:
          'As configurações necessárias para executar o corte no documento não foram encontradas.',
        CUT_AND_ROTATE_PARAMETERS_NOT_DEFINED:
          'As configurações necessárias para executar o corte e a rotação no documento não foram encontradas.',
        ROTATE_PARAMETER_NOT_DEFINED:
          'As configurações necessárias para executar a rotação no documento não foram encontradas.',
        DOCUMENTS_DIRECTORY_INVALID:
          'A pasta do documento não foi encontrada, processo cancelado. Por favor, entre em contato com o suporte.',
        CREATE_CERTIFICATE_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar o processo de assinatura, processo cancelado. Por favor, entre em contato com o suporte.',
        CREATE_OUTPUT_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar o processo de assinatura, processo cancelado. Por favor, entre em contato com o suporte.',
        CREATE_ZIP_OUTPUT_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar o processo de assinatura, processo cancelado. Por favor, entre em contato com o suporte.',
        CREATE_ZIP_FILE_ERROR:
          'Ocorreu um erro ao criar o arquivo zip para publicação. Por favor, tente novamente.',
        CERTIFICATE_NOT_FOUND:
          'Não foi encontrado um certificado válido para assinar, por favor, tente novamente.',
        CREATE_CERTIFICATE_FILE_ERROR:
          'Não foi possível gerar os arquivos do certificado eletrônico para assinar os documentos, processo cancelado. Por favor, entre em contato com o suporte.',
        CREATE_PRIVATE_KEY_FILE_ERROR:
          'Não foi possível criar a chave privada do certificado eletrônico para assinar os documentos, processo cancelado. Por favor, entre em contato com o suporte.',
        SIGNATURE_PROCESS_ENDS_WITH_ERRORS:
          'O processo de assinatura de documentos falhou, tente novamente.',
        SIGNATURE_POSITION_INVALID:
          'Foi detectada uma posição de assinatura inválida. Por favor, configure novamente a posição de assinatura no ABM de documentos antes de tentar novamente o processo.',
        INVALID_PASSPHRASE_FOR_SUPPLIED_PRIVATE_KEY:
          'Erro ao validar a chave privada com a senha do certificado. É necessário reiniciar a publicação. Processo cancelado.',
        CERTIFICATE_IS_DISABLED:
          'O certificado selecionado não está ativo e pode ter expirado. Por favor, tente com outro certificado ou crie um novo.'
      },
      modal: {
        title: 'Detalhes do processo',
        reportTo: 'Relatório enviado para',
        file: 'Arquivo',
        period: 'Período',
        docQuantity: 'Número de documentos processados',
        docType: 'Tipo de documento'
      }
    },
    searchEmployee: {
      notificationReminder: {
        notified: 'Notificados',
        notNotified: 'Não notificados',
        totalNotified: 'Total notificados',
        download: {
          part1: 'Baixe o',
          part2: 'Relatório de notificações'
        },
        cancel: 'Cancelar',
        send: 'Enviar',
        accept: 'Aceitar'
      },
      tableStatus: {
        inactive: 'Inativo',
        active: 'Ativo',
        total: 'Total'
      },
      add: 'Adicionar'
    },
    employeePanel: {
      sectionsTitles: {
        personalData: 'Dados pessoais',
        configuration: 'Configuração',
        onboarding: 'Integração'
      },
      changeTemplate: {
        currentTemplate: 'Modelo atual',
        newTemplate: 'Novo Modelo',
        message:
          'Ao mudar o modelo todos os dados que o empregado tiver carregado serão perdidos.',
        swal: {
          title: 'Tem certeza de que deseja mudar o modelo?',
          message:
            'Ao mudar o modelo todos os dados que o empregado tiver carregado serão perdidos.'
        }
      },
      identifyGenre: {
        man: 'Homem',
        woman: 'Mulher',
        noBinary: 'Não binário',
        other: 'Prefiro não indicar'
      },
      fieldValidation: 'Não são permitidos hífens',
      importantTitle: 'Importante',
      noValidCuil: 'O CUIL não deve conter hífens.',
      userAccount: 'Conta Salário',
      userAccountCTS: 'Conta CTS',
      particularAddress: 'Particular',
      onboardingActivate: 'Ativar Integração',
      errorDoc: 'Ocorreu um erro ao processar o documento',
      errorDocMultiple: 'Ocorreu um erro ao processar os documentos',
      requestDoc: 'Solicitar recarregar o documento.',
      requestDocMultiple: 'Solicitar recarregar os documentos.',
      buttonCancel: 'Cancelar',
      buttonRequest: 'Solicitar'
    }
  }
})
